/* KLIK product page layer (2026-10-12) — one buy box and one sticky buy bar for every product family.
   Presentation only: the family controllers (DPO sofa studio, room studio, ready sets) keep selection, pricing,
   3D, validation and add-to-cart. This layer adds what a shopper needs next to the price — instalments, a
   delivery date, guarantees, help — makes "Order as shown" the main action and keeps it in reach while scrolling.
   Styles: assets/klik-pdp.css. */
(() => {
  "use strict";
  if (window.__KLIK_PDP__ || !document.querySelector("[data-kpd-page], #kl-room-shop")) return;
  window.__KLIK_PDP__ = true;
  const ar = (document.documentElement.lang || "").startsWith("ar");
  const t = (en, arabic) => (ar ? arabic : en);
  const make = (tag, cls, html) => {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (html != null) node.innerHTML = html;
    return node;
  };
  const svg = (d, extra = "") =>
    `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"${extra}>${d}</svg>`;
  const CART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" focusable="false"><path d="M3 4h2.2l2.1 10.2a1.6 1.6 0 0 0 1.6 1.3h8.3a1.6 1.6 0 0 0 1.6-1.2L20.5 8H6.1"/><circle cx="9.5" cy="19.5" r="1.3"/><circle cx="17" cy="19.5" r="1.3"/></svg>';
  const ICON = {
    truck: svg('<path d="M3 6h11v10H3zM14 9h4l3 3v4h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/>'),
    made: svg('<path d="M4 20h16M6 20V9l6-5 6 5v11"/><path d="M10 20v-5h4v5"/>'),
    shield: svg('<path d="M12 3 4 6v6c0 5 8 9 8 9s8-4 8-9V6z"/><path d="m8.5 12 2.5 2.5 4.5-5"/>'),
    lock: svg('<rect x="5" y="10" width="14" height="10" rx="1.5"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/>'),
    back: svg('<path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/>'),
    pin: svg('<path d="M12 21s-7-6.1-7-11.5A7 7 0 0 1 19 9.5C19 14.9 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/>'),
    chat: svg('<path d="M20 12a8 8 0 0 1-11.9 7L4 20l1.1-4A8 8 0 1 1 20 12z"/>'),
    cube: svg('<path d="m12 3 8 4.5v9L12 21l-8-4.5v-9z"/><path d="m4 7.5 8 4.5 8-4.5M12 12v9"/>'),
    ruler: svg('<path d="M3 16.5 16.5 3 21 7.5 7.5 21z"/><path d="m7 12.5 2 2M9.1 10.4l1.3 1.3M11.1 8.4l2 2M13.1 6.4l1.3 1.3"/>'),
  };
  // §4 copy through the facts block (klik-fact data) when it is on the page, else the §4 default
  const fact = (key, form, en, arabic) => {
    try {
      const v = window.KlikFacts?.get?.(key, form);
      if (v) return v;
    } catch (e) {}
    return t(en, arabic);
  };
  const esc = (s) => String(s || "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]);
  // Latin names and codes inside Arabic text are isolated (§1.8)
  // cta2-fix2: a single Latin letter is isolated too («حرف L · 300 × 200 سم» kept the L next to سم)
  const bidi = (s) => (ar ? esc(s).replace(/([A-Za-z](?:[A-Za-z0-9 .&+\/-]*[A-Za-z0-9])?|[A-Z]{1,4}-?\d[\d-]*)/g, "<bdi>$1</bdi>") : esc(s));
  const productId = () => {
    try {
      // p4-cta-2: the buy box's own id (server, klik-pdp-actions) while the page is still loading
      return String(JSON.parse(document.getElementById("KlikDecisionProduct")?.textContent || "{}").id || window.ShopifyAnalytics?.meta?.product?.id || document.querySelector("[data-kpdp-actions][data-product-id]")?.dataset.productId || "");
    } catch (e) {
      return String(window.ShopifyAnalytics?.meta?.product?.id || "");
    }
  };
  // p5-cfg-entry A16: every klik_pdp_* event names the family (kz | kd | hz | kf | bedroom | dining | ready): the studio's
  // own order key on the wizard, else the page. KlikTrack (area E) normalises and publishes; else Shopify analytics.
  const familyOf = () => {
    try {
      const w = document.querySelector("[data-klik-dpo-wizard]");
      const oas = String(w?.dataset.klikOrderAsShown || "").toLowerCase();
      if (/^(kz|kd|hz)$/.test(oas)) return oas;
      if (document.querySelector("[data-furniture-configurator], [data-furniture-product-page], [data-kfp]")) return "kf";
      const dk = document.querySelector("[data-klik-delivery-kind]");
      if (dk?.dataset.klikReady === "true") return "ready";
      if (document.querySelector("#kl-room-shop, .kl-pdp-panel")) return dk?.dataset.klikDeliveryKind === "dining" || /dining/i.test(location.pathname) ? "dining" : "bedroom";
      const pk = String(w?.dataset.pilotKind || document.querySelector("[data-pilot-kind]")?.dataset.pilotKind || "").toLowerCase();
      return pk === "sofa" ? "kz" : pk === "sectional" ? "kd" : pk === "hazel" ? "hz" : pk;
    } catch (e) {
      return "";
    }
  };
  const publish = (name, extra) => {
    const payload = Object.assign({ productId: productId(), family: familyOf() }, extra || {});
    try {
      if (typeof window.KlikTrack === "function") return void window.KlikTrack(name, payload);
    } catch (e) {}
    try { window.Shopify?.analytics?.publish?.(name, payload); } catch (e) {}
  };

  // p5-cfg-entry A5 (KZ-12, M6): the error names the button the shopper sees ("Buy as pictured" / "Add to cart")
  const ADD_ERROR = (name) => {
    const n = String(name || t("Add to cart", "أضف إلى السلة")).trim();
    return t(`Couldn't add it just now. Tap "${n}" again; your choices are kept.`, `تعذّرت الإضافة الآن. اضغط «${n}» مرة أخرى، اختياراتك محفوظة.`);
  };
  const ADD_BUSY = (name) => {
    const n = String(name || t("Add to cart", "أضف إلى السلة")).trim();
    return t(`The store is busy for a moment. Tap "${n}" again in a minute.`, `المتجر مشغول للحظات. اضغط «${n}» مرة أخرى بعد دقيقة.`);
  };
  const ADDING = () => t("Adding to cart…", "جارٍ الإضافة إلى السلة…");
  const STEPS = () => [t("Checking your design", "نتحقق من تصميمك"), t("Saving your design", "نحفظ تصميمك"), t("Almost done", "لحظات")];
  // the quiet second line under "Adding to cart…" (one label for the whole add; only this line moves on)
  const addStep = (button, i) => {
    if (!button) return;
    let node = button.querySelector(".kpdp-cta-add__step");
    if (i < 0) return void (node && (node.textContent = ""));
    if (!node) {
      const host = button.querySelector(".kpdp-cta-add__text, .kpdp-cta-3d__text") || button;
      node = make("small", "kpdp-cta-add__step");
      node.setAttribute("aria-hidden", "true");
      host.append(node);
    }
    const text = STEPS()[Math.min(i, 2)];
    if (node.textContent !== text) node.textContent = text;
  };
  // the design line and the total for a human fallback (WhatsApp) and the help link: what the shopper sees
  const designLine = () => (document.querySelector(".kpdp-fv .kpdp-cta-asshown__text, .kpdp-cta-inside .kpdp-cta-asshown__text, .kpdp-cta .kpdp-cta-asshown__text")?.textContent || "").replace(/\s+/g, " ").trim();
  const shownCents = () => Number(document.querySelector(".kp6-total [data-kprice-current], .kl-pdp-price [data-kprice-current]")?.dataset.kpriceCurrent) || 0;
  const titleNoBrand = () => (([...document.querySelectorAll("main h1, h1")].find((h) => h.getClientRects().length) || document.querySelector("h1"))?.textContent || "").replace(/\s+/g, " ").replace(/^(?:KLIK|كليك)\s+(?!Decor\b|ديكور)/, "").trim();
  // fast-convert RUN (page budget): the same name without reading layout (the first h1 outside hidden parts), for what is
  // built while the page loads; titleNoBrand() (the visible h1) is read again when the shopper uses the link
  const titleQuick = () => (([...document.querySelectorAll("main h1, h1")].find((h) => !h.closest("[hidden], dialog, template, [aria-hidden='true'], .visually-hidden, .kpdp-fv")) || document.querySelector("h1"))?.textContent || "").replace(/\s+/g, " ").replace(/^(?:KLIK|كليك)\s+(?!Decor\b|ديكور)/, "").trim();
  const waHref = (extra) => {
    const ctx = Object.assign({ topic: "product", productTitle: titleNoBrand(), summary: designLine(), totalCents: shownCents(), url: location.href.split(/[?#]/)[0] }, extra || {});
    try {
      const href = window.KlikWhatsApp?.build?.(ctx);
      if (href) return href;
    } catch (e) {}
    return `https://wa.me/966503889913?text=${encodeURIComponent(t("Hello KLIK, I would like to ask about ", "مرحبًا كليك، أود الاستفسار عن ") + ctx.productTitle + "\n" + ctx.summary + "\n" + ctx.url)}`;
  };

  /* ---------- §1.13 / §3.1 KlikOrderAsShown: "Add to cart" adds the design on screen through the family's adapter
     (adapter.add() → KlikCartAdded, the confirmation sheet). A family without an adapter keeps today's path (its
     studio review step, which has one Add button). ---------- */
  if (!window.KlikOrderAsShown) {
    const adapters = new Map();
    let busy = false;
    let job = null;
    // p4-cta: the adapter's own family first (buy-fix request: room pages have no data-pilot-kind)
    const sheetCtx = () => ({ family: adapters.get(productId())?.family || document.querySelector("[data-pilot-kind]")?.dataset.pilotKind || "", productId: productId(), handle: location.pathname.split("/products/")[1]?.split(/[/?#]/)[0] || "" });
    // p4-cta: the studio's first view (dialog.kpdp-fv) closes and gives its history entry back before the sheet opens
    const openSheet = (j, result) => {
      if (j.shown) return;
      j.shown = true;
      const show = () => {
        try {
          return window.KlikCartAdded ? window.KlikCartAdded(result, sheetCtx()) : location.assign("/cart");
        } catch (e) {
          location.assign("/cart");
        }
      };
      let before = null;
      try { before = window.__kpdpFvBeforeSheet?.(); } catch (e) {}
      return before && typeof before.then === "function" ? before.then(show, show) : show();
    };
    // the inline alert under the Add button (role=alert); the sticky bar shows its own copy while it is on screen
    const addAlert = (button, show, text) => {
      if (!button) return;
      const host = button.closest(".kpdp-cta") || button.parentElement;
      let node = host?.querySelector(".kpdp-cta-error");
      if (!show) {
        if (node && !node.hidden) ((node.hidden = true), (node.textContent = ""));
        const wa = host?.querySelector(".kpdp-cta-wa");
        if (wa && !wa.hidden) wa.hidden = true;
        return;
      }
      if (!node) {
        node = make("p", "kpdp-cta-error");
        node.setAttribute("role", "alert");
        node.hidden = true;
        button.after(node);
      }
      node.textContent = text || ADD_ERROR();
      node.hidden = false;
      // p5-cfg-entry A5: under any add error, a human way to finish the order ("Or order on WhatsApp")
      let wa = host?.querySelector(".kpdp-cta-wa");
      if (!wa) {
        wa = make("p", "kpdp-cta-wa");
        wa.innerHTML = `<a href="#" target="_blank" rel="noopener noreferrer"><span class="kpdp-ico" aria-hidden="true">${ICON.chat}</span><span>${t("Or order on WhatsApp", "أو اطلبه على واتساب")}</span></a>`;
        wa.querySelector("a").addEventListener("click", (e) => {
          e.currentTarget.href = waHref();
          publish("klik_pdp_whatsapp_fallback");
        });
        node.after(wa);
      }
      wa.querySelector("a").href = waHref();
      wa.hidden = false;
    };
    // v3-fix1: a finger, pointer or focus on Add to cart (buy box or sticky bar) starts the family's warm-up at once
    // (adapter.warm: the corner sofas load their product options), before the tap lands
    for (const type of ["pointerdown", "touchstart", "focusin"])
      document.addEventListener(type, (e) => {
        if (!e.target.closest?.("[data-kpdp-add], .kflow-as-shown, .kpdp-bar-buy")) return;
        try { adapters.get(productId())?.warm?.(); } catch (err) {}
      }, { capture: true, passive: true });
    window.KlikOrderAsShown = Object.freeze({
      register(id, adapter) {
        if (id && adapter && typeof adapter.add === "function") {
          adapters.set(String(id), adapter);
          try { document.dispatchEvent(new CustomEvent("klik:order-as-shown-ready", { detail: { productId: String(id) } })); } catch (e) {}
        }
      },
      get: (id) => adapters.get(String(id || productId())),
      tryAdd(box, button, opts) {
        const adapter = adapters.get(productId());
        if (!adapter) return false;
        if (busy) return true;
        busy = true;
        // §1.13a states on the button (data-state loading → success | error); only the label text changes, the icon and
        // the price inside the button stay
        // p4-cta-2: opts.label = the node whose text carries the states (the one primary's title on a furniture chip add)
        const labelNode = opts?.label || button?.querySelector(".kpdp-cta-add__label") || button;
        const label = (button?.dataset.state === "error" && button.__kpdpLabel) || (/^(Adding|جارٍ الإضافة)/.test(labelNode?.textContent || "") && button?.__kpdpLabel) || labelNode?.textContent || "";
        addAlert(button, false);
        // (p4-cta-2: the spoken name gives way to the live label while the add runs)
        if (button) (button.removeAttribute("aria-label"), button.setAttribute("aria-busy", "true"), (button.dataset.state = "loading"), (labelNode.textContent = ADDING()), addStep(button, 0));
        // p5-cfg-entry A5: the steps move on quietly under the one label (time, or the adapter's "sending" stage)
        const stepT = [setTimeout(() => button?.dataset.state === "loading" && addStep(button, 1), 3500), setTimeout(() => button?.dataset.state === "loading" && addStep(button, 2), 9000)];
        publish("klik_order_as_shown_opened");
        // buy-fix 2026-10-22: a failed or stalled add is never silent. The adapter's add runs once (a retry waits for the
        // same add, never a second one); after 15 s the button reads "Couldn't add · Try again" with an inline alert, and an
        // add that still lands later opens the sheet then (the line is in the cart).
        const j =
          job ||
          (job = (() => {
            const next = { shown: false, late: false, at: Date.now(), sentAt: 0, onSent: [] };
            // cta2-fix2: the adapter gets a signal that aborts when the limit below fires (kz stops resending a throttled
            // set). A tap kept before the adapter registered (opts.early, klik-pdp-actions) whose add rejects within 2.5 s
            // (the family's data was not ready yet, e.g. the ready-stock quote) is retried once, quietly, after 2 s.
            next.ctl = typeof AbortController === "function" ? new AbortController() : null;
            // v3-fix1: an adapter that reports its stages calls stage("sending") when its add request goes out
            next.stage = (name) => {
              if (name !== "sending" || next.sentAt) return;
              next.sentAt = Date.now();
              try { if (button?.dataset.state === "loading") addStep(button, 2); } catch (e) {}
              next.onSent.splice(0).forEach((fn) => { try { fn(); } catch (e) {} });
            };
            const run = () => adapter.add({ signal: next.ctl ? next.ctl.signal : undefined, stage: next.stage });
            next.promise = Promise.resolve()
              .then(run)
              .catch((e) => {
                if (!opts?.early || next.retried || Date.now() - next.at > 2500 || next.ctl?.signal.aborted || e?.details?.status === 429) throw e;
                next.retried = true;
                return new Promise((ok) => setTimeout(ok, 2000)).then(run);
              });
            next.promise
              .then((result) => {
                if (!next.late || next.shown) return;
                if (button && button.dataset.state === "error") (addAlert(button, false), (labelNode.textContent = button.__kpdpLabel || label), (button.dataset.state = "idle"));
                openSheet(next, result);
              }, () => {})
              .finally(() => job === next && (job = null));
            return next;
          })());
        let added = false;
        let timer = 0;
        // buy-fix (CO-7): an adapter whose add is known to take longer sets its own limit (kz: prepare + 3 ValidateForm +
        // add ≈ 19–38 s on staging), so a set that is still being added is not reported as failed at 15 s
        // v3-fix1 (2026-10-22): "Couldn't add" means the add itself failed. An adapter that reports its stages
        // (adapter.stages: the corner sofas, whose cold tap waits for the product options to load) gets prepareMs (60 s)
        // to load its options and dress the pictured design, and its limitMs only from the moment its add request goes
        // out. A limit that falls while the page is in the background (timers and frames paused) waits for the shopper
        // to come back, then 4 s more.
        const limitMs = Number(adapter.limitMs) > 0 ? Number(adapter.limitMs) : 15000;
        const limit = new Promise((_, no) => {
          const fire = () => (document.hidden ? document.addEventListener("visibilitychange", () => arm(4000), { once: true }) : no(Error("timeout")));
          const arm = (ms) => (clearTimeout(timer), (timer = setTimeout(fire, Math.max(0, ms))));
          if (!adapter.stages) return arm(limitMs);
          if (j.sentAt) return arm(limitMs - (Date.now() - j.sentAt));
          arm(Number(adapter.prepareMs) > 0 ? Number(adapter.prepareMs) : 60000);
          j.onSent.push(() => arm(limitMs));
        });
        Promise.race([j.promise, limit])
          .then((result) => {
            added = true;
            return openSheet(j, result);
          })
          .catch((e) => {
            j.late = true;
            if (e && e.message === "timeout") j.ctl?.abort();
            else j.error = e;
          })
          .finally(() => {
            clearTimeout(timer);
            stepT.forEach(clearTimeout);
            busy = false;
            if (!button) return;
            button.removeAttribute("aria-busy");
            addStep(button, -1);
            if (added) {
              labelNode.textContent = label;
              button.dataset.state = "success";
              setTimeout(() => button.dataset.state === "success" && (button.dataset.state = "idle"), 2200);
              return;
            }
            // p5-cfg-entry A5: the button keeps its own name, so the message can say which button to tap again
            button.__kpdpLabel = label;
            labelNode.textContent = label;
            button.dataset.state = "error";
            try { publish("klik_pdp_add_failed", { status: Number(j.error?.details?.status ?? j.error?.status) || 0, timeout: !j.error }); } catch (e) {}
            // cta2-fix2: a throttled store (429) says so, in the shopper's language, instead of "check your connection"
            const d = j.error?.details;
            // pre-cart (BV-4): the room and table adapters report a throttled store only in their message (Shopify's
            // "Please try again in a few minutes", or their own "store is busy"): the same busy copy as every buy box.
            // p4-cta-2: only a real throttle (HTTP 429) is "busy"; a connection failure (status 0, a network error, an aborted
            // request) keeps the connection message even when the adapter's own text says "busy"
            const msg = String(j.error?.message || "");
            const status = Number(d?.status ?? j.error?.status ?? NaN);
            const offline = status === 0 || /failed to fetch|networkerror|network error|load failed|aborted/i.test(msg);
            const busyMsg = /\b429\b|too many (attempts|requests)|try again in a few minutes|store is busy|المتجر مشغول/i.test(msg);
            const throttled = !offline && (status === 429 || d?.busy === true || (Number.isNaN(status) && busyMsg));
            addAlert(button, true, throttled ? (status !== 429 && d?.busy && msg ? msg : ADD_BUSY(label)) : ADD_ERROR(label));
          });
        return true;
      },
    });
  }

  /* ---------- facts about this product, published by the details section ---------- */
  const marker = () => document.querySelector("[data-klik-delivery-kind]");
  const kind = () => marker()?.dataset.klikDeliveryKind || document.querySelector("[data-delivery-line][data-rule='threshold']")?.dataset.kind || "standard";
  const ready = () => marker()?.dataset.klikReady === "true";

  /* ---------- delivery date ----------
     p5-cfg-entry A11 (KD-8, M11): the made-to-order promise as a date ("Delivered by Wed 18 Nov at the latest"), ON since
     2026-10-23; ?klik-eta=0 turns it off for a page view. Never "approval". Western digits.
     W7 (build-3 track B, 28 Oct 2026): ONE clock. The Sunday–Thursday business days (Riyadh calendar), the holiday list and
     the 15-day rule live in assets/klik-eta.js (window.KlikEta), which the made-to-order cart lines and the "Added" sheet
     use too, so all three print the same date. When no tag on the page loaded it first, this file loads it at once
     (KLIK_ETA_V: bump it, and the same constant in klik-cart-added.js, when klik-eta.js changes). Until it is there the
     buy-box line keeps its place with its words hidden (3 s at most, then the words without a date show); the line and the
     first view's lead are filled the moment it arrives (klik:eta-ready). */
  const KLIK_ETA_V = "w7a";
  (() => {
    if (window.KlikEta || document.querySelector("script[data-klik-eta-src]")) return;
    const base = assetBase();
    if (!base) return;
    const sc = document.createElement("script");
    sc.src = base + "klik-eta.js?v=" + KLIK_ETA_V + "-" + new Date().toISOString().slice(0, 10).replace(/-/g, "");
    sc.async = true;
    sc.setAttribute("data-klik-eta-src", "");
    document.head.append(sc);
  })();
  const etaOff = /[?&]klik-eta=0(&|$)/.test(location.search);
  const longDate = (d) =>
    new Intl.DateTimeFormat(ar ? "ar-SA-u-ca-gregory-nu-latn" : "en-GB", { weekday: "short", day: "numeric", month: "short" }).format(d);
  // "Tue 27 Oct – Sun 1 Nov": business days 2–7 (ready to ship)
  const dateRange = () => `<bdi>${longDate(window.KlikEta.by(2))}</bdi> – <bdi>${longDate(window.KlikEta.by(7))}</bdi>`;
  const etaOn = () => !!window.KlikEta?.enabled && !ready();
  // the buy-box line's head, and the first view's lead (made to order)
  const readyHead = () => (window.KlikEta ? t("Delivered ", "يصلك ") + dateRange() : t("Delivered in 1–7 business days", "يصلك خلال 1–7 أيام عمل"));
  const mtoHead = () => (etaOn() ? esc(window.KlikEta.label(15)) : t("Delivered in up to 15 business days", "يصلك خلال 15 يوم عمل كحد أقصى"));
  const etaWaiting = new Set();
  const waitEta = (node) => {
    // (?klik-eta=0 keeps the made-to-order words; the ready-to-ship range was never behind that switch)
    if (!node || window.KlikEta || (etaOff && !node.closest(".kpdp-delivery--ready"))) return;
    node.style.visibility = "hidden";
    etaWaiting.add(node);
    setTimeout(() => (node.style.visibility = ""), 3000);
  };
  if (!window.KlikEta)
    document.addEventListener("klik:eta-ready", () => {
      etaWaiting.forEach((node) => {
        if (node.isConnected) node.innerHTML = node.closest(".kpdp-delivery--ready") ? readyHead() : mtoHead();
        node.style.visibility = "";
      });
      etaWaiting.clear();
      document.querySelectorAll(".kpdp-fv__lead").forEach((node) => (node.innerHTML = mtoHead()));
    }, { once: true });

  /* ---------- the buy box ---------- */
  /* wave1 pdp P0-2 DL-5 (2026-10-27): one delivery-fee sentence, the same rule as checkout's delivery profiles (read
     27 Oct): free delivery and installation on everything except bedroom SETS under SAR 6,000 and dining SETS under
     SAR 3,000, which pay SAR 300. A set at or above its threshold says "free delivery and installation on this set"
     (never "Free delivery from SAR 6,000" on an order that already qualifies); below it, the fee and the rule. The room
     studio keeps its own threshold line live ([data-delivery-line] data-free, campaign price), so this line follows it. */
  const setFeeState = () => {
    const k = kind();
    if (k !== "bedroom" && k !== "dining") return null;
    const rule = document.querySelector("[data-delivery-line][data-rule='threshold']");
    const threshold = Number(rule?.dataset.threshold) || (k === "bedroom" ? 600000 : 300000);
    const fee = Number(rule?.dataset.fee) || 30000;
    // the room studio's live line first; else the price block's own "what the price includes" line (klik-room-incl, the
    // set as pictured, server-side) so the box never says "SAR 300" for a moment before the studio has booted
    const incl = document.querySelector("[data-price-incl][data-free]");
    let free;
    if (rule && rule.dataset.free != null) free = rule.dataset.free === "true";
    else if (incl) free = incl.dataset.free === "true";
    else {
      const cur = Number(document.querySelector(".kl-pdp-price [data-kprice-current], .kp6-total [data-kprice-current]")?.dataset.kpriceCurrent) || 0;
      free = cur > 0 && cur >= threshold;
    }
    return { k, threshold, fee, free };
  };
  const sar = (cents) => {
    const n = new Intl.NumberFormat("en-US").format(Math.round(cents / 100));
    return ar ? `${n} ريال` : `SAR ${n}`;
  };
  const feeText = () => {
    const s = setFeeState();
    if (!s) return fact("delivery_sofas", "short", "Free delivery and installation", "توصيل وتركيب مجاني");
    if (s.free) return t("Free delivery and installation on this set", "التوصيل والتركيب مجاني لهذا الطقم");
    // wave1-fix pdp-07: checkout counts only the set's own items toward its threshold (the set profiles hold only the set
    // products), so the sentence names the set, never "bedroom/dining orders" (a separate piece would not remove the fee)
    return t(`Delivery ${sar(s.fee)} · free on orders from ${sar(s.threshold)} · installation included`, `التوصيل ${sar(s.fee)} · مجاني للطلبات من ${sar(s.threshold)} · التركيب مشمول`);
  };
  // the set line follows the room studio's threshold line and the buy-box total (pieces added or removed in the studio)
  const liveFee = (box) => {
    if (!setFeeState()) return;
    const node = box.querySelector(".kpdp-fee");
    if (!node) return;
    const paint = () => {
      const text = feeText();
      if (node.textContent !== text) node.textContent = text;
    };
    let queued = false;
    const later = () => queued || ((queued = true), requestAnimationFrame(() => ((queued = false), paint())));
    const rule = document.querySelector("[data-delivery-line][data-rule='threshold']");
    if (rule) new MutationObserver(later).observe(rule, { attributes: true, attributeFilter: ["data-free"] });
    const total = document.querySelector(".kl-pdp-price [data-total], .kp6-total");
    if (total) new MutationObserver(later).observe(total, { childList: true, subtree: true, characterData: true });
  };
  function deliveryBlock() {
    const fee = `<span class="kpdp-fee">${esc(feeText())}</span>`;
    const box = make("div", "kpdp-delivery " + (ready() ? "kpdp-delivery--ready" : "kpdp-delivery--custom"));
    if (ready()) {
      box.innerHTML = `<span class="kpdp-ico">${ICON.truck}</span><p><strong data-kpdp-eta>${readyHead()}</strong><span>${fee}<span class="kpdp-sep"> · </span><span class="kpdp-nowrap">${t("usually 1–7 business days", "عادةً خلال 1–7 أيام عمل")}</span></span></p>`;
    } else {
      // pdpm-build: a design sold one way only has no switch above the price, so the kind is named here ("Made to order"),
      // next to the lead time; with the switch on the page it already says it
      const kindLine = document.querySelector(".kpdp-mode--two:not(.kpdp-mode--ready-twin)") ? "" : `${t("Made to order", "تفصيل حسب الطلب")}<span class="kpdp-sep"> · </span>`;
      // W7: the dated layout while the clock is still loading too (its date fills the hidden head), so nothing moves
      const dated = etaOn() || (!window.KlikEta && !etaOff);
      // data-klik-eta: the clock repaints this head too when a page kept open (or restored from the back cache) shows a new day
      box.innerHTML = `<span class="kpdp-ico">${ICON.made}</span><p><strong data-kpdp-eta data-klik-eta="15" data-klik-eta-form="long">${mtoHead()}</strong><span>${kindLine}${dated ? t("Up to 15 business days", "خلال 15 يوم عمل كحد أقصى") + '<span class="kpdp-sep"> · </span>' : ""}${fee}</span></p>`;
    }
    waitEta(box.querySelector("[data-kpdp-eta]"));
    return box;
  }
  /* wave1 pdp P0-3 PDP-4: wood, stone and metal pieces (coffee, side and bedside tables, wardrobes, chests, dressing
     tables) have no fabric, so their warranty reads "On workmanship" ("fabric excluded" read like a hidden catch on a
     wooden table). Anything upholstered, and every bedroom or dining set, keeps "fabric excluded". */
  const hardPiece = () => {
    const type = String(window.ShopifyAnalytics?.meta?.product?.type || "").toLowerCase().trim();
    const path = location.pathname.toLowerCase();
    if (/ottoman|pouf|footstool|stool|bench|chair|sofa|sectional|daybed|bedroom[- ]set|dining[- ]set|-bed(?![a-z])|بوف|كنب|كرسي|سرير/.test(type + " " + path)) return false;
    return (
      /coffee-table|end-table|side-table|console|tv-unit|wardrobe|chest|bedside|nightstand|dressing|dresser|vanity|sideboard|cabinet|desk|shelf|bookcase/.test(path) ||
      /^(table|coffee table|side table|end table|console|tv unit|wardrobe|chest of drawers|bedside table|dressing table.*)$/.test(type)
    );
  };
  /* W8 (conversion build 2, 27 Oct 2026): the no-returns rule is said here, next to what lowers the risk: the 12-hour
     full refund above it, faulty pieces repaired or replaced in the same line (the cart's own words, klik-fact
     no_returns), the warranty, and right below in the help row the showrooms and the home measuring visit. */
  const noReturns = () => esc(fact("no_returns", "long", "No returns after delivery; faulty pieces repaired or replaced", "لا إرجاع بعد التوصيل، ونصلح القطع المعيبة أو نستبدلها"));
  function trustList() {
    const list = make("ul", "kpdp-trust");
    const items = [
      [ICON.shield, t("2-year warranty", "ضمان سنتين"), hardPiece() ? t("On workmanship", "على التصنيع") : t("On workmanship, fabric excluded", "على التصنيع، عدا القماش")],
      ready()
        ? [ICON.back, t("Change or cancel in 12 hours", "عدّل أو ألغِ خلال 12 ساعة"), noReturns()]
        : [ICON.back, esc(fact("cancellation", "short", "Full refund if you cancel within 12 hours", "استرداد كامل عند الإلغاء خلال 12 ساعة")), noReturns()],
      [ICON.lock, t("Secure checkout", "دفع آمن"), ar ? "<bdi>Apple Pay</bdi> ومدى والبطاقات" : "Apple Pay, mada and cards"],
    ];
    list.innerHTML = items.map(([icon, title, sub]) => `<li><span class="kpdp-ico">${icon}</span><span><strong>${title}</strong><small>${sub}</small></span></li>`).join("");
    return list;
  }
  function payLine() {
    // K-069: the §4 line from the server template (klik-payment-options, official marks) when the page has it
    const tpl = document.querySelector("template[data-klik-bnpl-template]");
    if (tpl?.content.firstElementChild) {
      const node = tpl.content.firstElementChild.cloneNode(true);
      node.dataset.kpdpPay = "1";
      return node;
    }
    const line = make("p", "kpdp-pay");
    line.innerHTML = `<span>${t("Split your payment at checkout with", "قسّم دفعتك عند الدفع مع")}</span> <b class="kpdp-tabby">tabby</b> <b class="kpdp-tamara">tamara</b><small>${t("Subject to approval", "حسب الأهلية")}</small>`;
    return line;
  }
  // p5-cfg-entry A15: furniture with finishes (tables, casegoods) and rooms say "size or finish"; upholstery says fabric
  const finishFamily = () =>
    (!!document.querySelector("#kl-room-shop, .kl-pdp-panel") ||
      !!document.querySelector("[data-furniture-open], [data-kfp], [data-furniture-configurator]") ||
      /wardrobe|dresser|cabinet|sideboard|(^|\s)table$|دولاب|خزانة|تسريحة|طاولة/i.test(String(window.ShopifyAnalytics?.meta?.product?.type || "").trim())) &&
    !/ottoman|pouf|footstool|بوف/i.test(String(window.ShopifyAnalytics?.meta?.product?.type || "") + " " + location.pathname);
  /* wave1 pdp P0-3 PDP-5: the help row says what to send and when the reply comes ("Send a photo of your room on
     WhatsApp. We reply within 24 hours": the reply time is the site's stated 24 hours); the message is prefilled for a
     size question about this product (KlikWhatsApp topic "size", klik-whatsapp.liquid). Plan-a-visit (UX-01, builder ux):
     "See it in person" opens window.KlikVisitSheet when the page has it; otherwise it stays today's showrooms link. */
  function helpLine(scope) {
    const source = scope.querySelector(".klik-buying-help a[href*='wa.me'], .kflow-footer a[href*='wa.me'], a.kl-text-link[href*='wa.me']") || document.querySelector(".klik-buying-help a[href*='wa.me']");
    const name = document.querySelector("h1")?.textContent.trim() || "";
    const pageUrl = location.href.split(/[?#]/)[0];
    /* fast-convert RUN (page budget): built while the page loads, so the name comes from titleQuick() (no layout read; the
       visible-h1 read forced a style and layout pass of the whole page here, one of klik-pdp.js's two at start-up); the
       exact name is put in when the shopper reaches for the link */
    const sizeHref = (title) => {
      let h = "";
      try { h = window.KlikWhatsApp?.build?.({ topic: "size", productTitle: title || name, url: pageUrl }) || ""; } catch (e) {}
      return h || source?.href || `https://wa.me/966503889913?text=${encodeURIComponent(t("Hello KLIK, I have a question about ", "مرحبًا كليك، لدي سؤال عن ") + name + " " + pageUrl)}`;
    };
    const href = sizeHref(titleQuick());
    const showrooms = (ar ? "" : "") + (document.querySelector("a[href*='view=showrooms']")?.getAttribute("href") || "/pages/contact-us?view=showrooms");
    const help = make("div", "kpdp-help");
    /* W8 / home measuring visit (owner 27 Oct 2026: SAR 300, deducted from the order, branch cities only; the team brings
       fabric samples): a third row under "See it in person" that opens the same visit sheet on its home choice. Shown
       where a measuring visit with fabrics helps (upholstery and rooms), not on tables and wood casegoods (hardPiece). It
       carries the visit row's class so the help-row styles apply unchanged. */
    const homeRow = hardPiece()
      ? ""
      : `<a class="kpdp-help-visit kpdp-help-home" href="${showrooms}" data-kpdp-visit-kind="home"><span class="kpdp-ico">${ICON.ruler}</span><span><strong>${t("Home measuring visit", "زيارة منزلية لأخذ المقاسات")}</strong><small data-klik-riyal-ignore>${esc(fact("home_visit", "short", "In Riyadh, Jeddah and Dammam, with fabric samples. SAR 300, deducted from your order.", "في الرياض وجدة والدمام، ونُحضر لك عينات الأقمشة. 300 ريال تُخصم من طلبك."))}</small></span></a>`;
    help.innerHTML =
      `<a class="kpdp-help-chat" href="${esc(href)}" target="_blank" rel="noopener noreferrer"><span class="kpdp-ico">${ICON.chat}</span><span><strong>${finishFamily() ? t("Not sure about the size or finish?", "محتار في المقاس أو التشطيب؟") : t("Not sure about the size?", "محتار في المقاس؟")}</strong><small>${t("Send a photo of your room on WhatsApp. We reply within 24 hours.", "أرسل صورة غرفتك على واتساب، ونرد عليك خلال 24 ساعة.")}</small></span></a>` +
      `<a class="kpdp-help-visit" href="${showrooms}"><span class="kpdp-ico">${ICON.pin}</span><span><strong>${t("See it in person", "شاهده عن قرب")}</strong><small>${t("Riyadh, Jeddah and Dammam showrooms", "معارض الرياض وجدة والدمام")}</small></span></a>` +
      homeRow;
    const chat = help.querySelector(".kpdp-help-chat");
    if (chat) {
      let exact = false;
      const refresh = () => {
        if (exact) return;
        exact = true;
        const h = sizeHref(titleNoBrand());
        if (h && chat.getAttribute("href") !== h) chat.setAttribute("href", h);
      };
      for (const type of ["pointerdown", "focus", "mouseenter", "touchstart"]) chat.addEventListener(type, refresh, { passive: true });
    }
    help.querySelectorAll(".kpdp-help-visit").forEach((row) => row.addEventListener("click", (e) => {
      const vs = window.KlikVisitSheet;
      if (e.defaultPrevented || !vs || typeof vs.open !== "function" || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const link = e.currentTarget.href;
      const kind = e.currentTarget.dataset.kpdpVisitKind === "home" ? "home" : "showroom";
      const opener = e.currentTarget;
      e.preventDefault();
      try {
        const handle = location.pathname.split("/products/")[1]?.split(/[/?#]/)[0] || "";
        Promise.resolve(vs.open({ product: { title: titleNoBrand() || name, handle, url: pageUrl }, kind, source: "pdp", opener })).catch(() => location.assign(link));
      } catch (err) {
        location.assign(link);
      }
    }));
    return help;
  }
  /* ---------- how it is bought: made to order vs ready to ship, side by side (customers mixed the two up).
     A design sold both ways links its twin (klik-matching-product, from the product's metafields): the two become
     one switch at the top of the buy box. A design sold one way shows which way, with its delivery promise. ---------- */
  function modeSwitch(scope) {
    if (scope.querySelector(".kpdp-mode")) return;
    // cta2: the server switch (klik-matching-product part 'mode') is adopted, never rebuilt
    const ssr = document.querySelector("[data-kpdp-mode-ssr]");
    if (ssr) {
      const at = scope.querySelector(".kp7-initial-price, .kp6-price, .kl-pdp-price, .kp6-price-label");
      const spot = at ? at.closest(".kp7-initial-price") || at : null;
      if (spot && spot.previousElementSibling !== ssr && !ssr.contains(spot)) spot.before(ssr);
      return;
    }
    const twin = scope.querySelector("a.klik-matching-product") || document.querySelector("a.klik-matching-product");
    const isReady = ready();
    const finishOnly = (/wardrobe|chest of drawers|dresser|dressing table|nightstand|bedside|cabinet|sideboard|tv unit|bookcase|shelf|desk|(^|\s)table$|دولاب|خزانة|وحدة أدراج|تسريحة|كومود|طاولة|مكتب/i.test(String(window.ShopifyAnalytics?.meta?.product?.type||"").trim())||/\/products\/[^\/?#]*(coffee-table|side-table|console|wardrobe|dresser|vanity|bedside|chest|desk|shelf|cabinet|sideboard|tv-unit)/i.test(location.pathname));
    // §1.14 rule 2b: the number keeps its condition; a no-break space before "·" so an Arabic line never starts with it
    const sep = ' <span class="kpdp-sep">·</span> ';
    const custom = { label: t("Made to order", "تفصيل حسب الطلب"), sub: (finishOnly ? t("Your size & finish", "مقاسك وتشطيبك") : t("Your size & fabric", "مقاسك وقماشك")) + sep + `<span class="kpdp-nowrap">${t("up to 15 business days", "خلال 15 يوم عمل")}</span>` };
    const readyOpt = { label: t("Ready to ship", "جاهز للتوصيل"), sub: t("Set sizes", "مقاسات محددة") + sep + `<span class="kpdp-nowrap">${t("1⁠–⁠7 business days", "خلال 1⁠–⁠7 أيام عمل")}</span>` };
    const wrap = make("div", "kpdp-mode");
    wrap.setAttribute("role", "group");
    wrap.setAttribute("aria-label", t("How you buy this design", "طريقة شراء هذا التصميم"));
    const option = (o, current, href, kindName) =>
      current || !href
        ? `<span class="kpdp-mode-opt is-current" data-kind="${kindName}" aria-current="true"><strong>${o.label}</strong><small>${o.sub}</small></span>`
        : `<a class="kpdp-mode-opt" data-kind="${kindName}" href="${href}"><strong>${o.label}</strong><small>${o.sub}</small></a>`;
    if (twin) {
      const href = twin.getAttribute("href");
      wrap.classList.add("kpdp-mode--two");
      if (isReady) wrap.classList.add("kpdp-mode--ready-twin");
      wrap.innerHTML = isReady
        ? option(readyOpt, true, null, "ready") + option(custom, false, href, "custom")
        : option(custom, true, null, "custom") + option(readyOpt, false, href, "ready");
      twin.classList.add("kpdp-twin-moved");
    } else {
      wrap.innerHTML = isReady ? option(readyOpt, true, null, "ready") : option(custom, true, null, "custom");
    }
    const anchor = scope.querySelector(".kp7-initial-price, .kp6-price, .kl-pdp-price, .kp6-price-label");
    const host = anchor ? anchor.closest(".kp7-initial-price") || anchor : null;
    if (host) host.before(wrap);
    else scope.prepend(wrap);
  }
  /* ---------- "Make it yours" (2026-10-13, configurator rework: customising should be discoverable where everyone
     is, and start on the choice the shopper cares about). Made-to-order sofas and corner sofas show what the pictured
     design is — its size and fabric — as two rows above the buttons; each opens the 3D studio straight on that step
     through the buy box's own step links (kflow-overview), so the studio, prices and orders are unchanged. ---------- */
  const FABRICS = ["kf-1028-10", "kf-1038-10", "kf-1036-10", "kf-1018-10", "kf-1006-10", "kf-1027-10"];
  // the theme's own asset folder (…/cdn/shop/t/<theme>/assets/), taken from this script's own address
  function assetBase() {
    const own = [...document.querySelectorAll("script[src], link[href]")]
      .map((n) => n.getAttribute("src") || n.getAttribute("href") || "")
      .find((u) => /\/cdn\/shop\/t\/\d+\/assets\/klik-pdp\.(js|css)/.test(u)) ||
      [...document.querySelectorAll("script[src]")].map((n) => n.getAttribute("src")).find((u) => /\/cdn\/shop\/t\/\d+\/assets\//.test(u)) || "";
    const i = own.indexOf("/assets/");
    return i < 0 ? "" : own.slice(0, i + 8);
  }
  /* §1.13 (2026-10-21): ONE read-only summary line ("7-seat sofa set · Shown fabric", then the chosen size and fabric
     name after changes) with the swatch dots, no "Change" buttons; the studio opens from the one text link. It reads
     the buy box's own overview rows, which KlikProductFlow.sync fills from the studio state (klik:dpo-state), so it is
     bound to the same state as the studio and the review. Supplier codes are dropped (K-032). */
  // p4-cta-2: case-insensitive ("Off-white woven kf-1112-10" reached the first view)
  const CODE = /\s*[([]?\b(?:KF|KL|KD|KZ|SF|FB|[A-Z]{2,3})-?\d{3,5}(?:-\d{1,3})?\b[)\]]?/gi;
  // p4-cta: bare supplier numbers too ("Taupe charlotte jacquard 4595010013": the first view shows this line)
  const plain = (s) => String(s || "").replace(CODE, "").replace(/\s*\b\d{6,}\b/g, "").replace(/\s*[·|,]\s*$/, "").replace(/\s{2,}/g, " ").trim();
  /* §1.13a (2026-10-22): the as-pictured line (.kpdp-cta-asshown), the Add label and the price inside the Add button,
     bound to the same state as the studio (the overview rows KlikProductFlow.sync fills from klik:dpo-state, and the
     buy-box total). "As pictured: 7-seat sofa set · fabric shown" + "Add to cart · as pictured" while the configuration
     equals the pictured one; after a studio change "Your design: …" + "Add to cart" with the new price. */
  const NOISE = /estimated|starting|total|price as shown|shown fabric|vat|tax|excluded|included|تقديري|الإجمالي|إجمالي|الضريبة|بدون|مشمول|المعروض|الظاهر/i;
  // refine 2026-10-22: one separator ("|" from the room labels becomes "·"), OP-11 vocabulary («حرف L»)
  // p5-cfg-entry A15: the shape reads «شكل L» (never «حرف L»); runs read "300 + 200 cm"; no space before a comma
  const tidy = (s) => String(s || "").replace(/\s*\|\s*/g, " · ").replace(/حرف ال(?=\s|$)/g, "شكل L").replace(/حرف\s+L\b/g, "شكل L").replace(/(\d)\s*\+\s*(\d)/g, "$1 + $2").replace(/((?:L-shape|U-shape|شكل L|شكل U)\s*·\s*)(\d+(?:\.\d+)?)\s*[×x]\s*(\d+(?:\.\d+)?)(\s*(?:cm|سم))/g, "$1$2 + $3$4").replace(/\s+([,،])/g, "$1").replace(/\s{2,}/g, " ").trim();
  // p5-cfg-entry A15: fabric names through the studio's one naming function when it is loaded (Arabic shows no Latin word)
  const niceFabric = (x) => {
    try {
      const n = window.KlikFabricFlow?.name?.(x, { lang: ar ? "ar" : "en" });
      if (n && typeof n === "string") return n;
    } catch (e) {}
    return fabricName(typeof x === "string" ? x : plain(x?.name || ""));
  };
  // "Khaki · Woven / Beige Floral · Jacquard" → "Khaki woven / Beige floral jacquard" (EN; Arabic keeps the studio's words)
  // p4-cta: only " / " between two fabrics splits; an abbreviation such as "W/R" stays whole and in capitals
  // p4-cta-2: Arabic "colour · type" (the separator of the line itself) reads as one name: type first, the transliterations
  // fixed as in KlikFabricFlow (2.8): «أوف وايت · نسيج» → «قماش منسوج أبيض عاجي» (wave1 pdp P0-6 #20: «منسوج», the studio's
  // own word for woven, as a type after «قماش»)
  const fabricName = (s) =>
    ar
      ? s
          .split(/\s+\/\s+/)
          .map((part) => {
            const bits = part.split(/\s+·\s+/).map((b) => b.replace(/أوف وايت/g, "أبيض عاجي").replace(/تاوب/g, "بني رمادي").replace(/بنى/g, "بني").replace(/^\s*(?:نسيج|منسوج)\s*$/, "قماش منسوج").trim()).filter(Boolean);
            return bits.length === 2 ? `${bits[1]} ${bits[0]}` : bits.join(" ");
          })
          .join(" / ")
      : s
          .split(/\s+\/\s+/)
          .map((part) => part.split(/\s+·\s+/).join(" ").split(/\s+/).map((w, i) => (/^[A-Z]{1,3}(\/[A-Z]{1,3})+$/.test(w) ? w : i ? w.toLowerCase() : w.charAt(0) + w.slice(1).toLowerCase())).join(" "))
          .join(" / ");
  // p4-cta: where the one primary opens the studio straight away (no first view): the room builders (pages) and the
  // deep links (?studio=1, an edit from the cart, a shared design)
  const fvBuilder = () => /^\/pages\//.test(location.pathname) || !!document.querySelector("#kl-room-shop[data-bedroom-builder='true'], [data-bedroom-builder='true']");
  const fvLink = () => /[?&](studio=1|klik-edit=|klik_set_editor=|klik_sofa_mode=)/.test(location.search) || /klik-(config|design)=/.test(location.hash);
  // owner 2026-10-22 21:25 PT: "remove the buy as pictured option for custom made, I think ready to ship does that better …
  // configurator should always start with default or as pictured": made to order has no first view any more; the one
  // button opens the studio, which starts as pictured (ready to ship keeps its one-tap Add to cart)
  const fvNone = () => true;
  const fvDirect = () => fvNone() || fvBuilder() || fvLink();
  // p4-cta-2: ottomans and poufs are upholstered: "size & fabric" (tables and casegoods keep "size & finish")
  const upholstered = () => /ottoman|pouf|footstool|بوف/i.test(String(window.ShopifyAnalytics?.meta?.product?.type || "") + " " + location.pathname);
  // money in the store's own markup (klik-money: the riyal symbol in both languages)
  const riyal = (cents) =>
    `<span class="klik-riyal-price" dir="ltr"><span class="klik-riyal-symbol" aria-hidden="true"></span><span class="klik-riyal-amount">${new Intl.NumberFormat("en-US", { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(cents / 100)}</span><span class="visually-hidden"> ${t("SAR", "ريال")} </span></span>`;
  // the one primary's accessible name: "Design it in 3D, from 3,188.17 riyals, 10% off applied" (the visually hidden
  // campaign prefix inside klik-money read as "from With LAMMA10: …")
  const spokenPrice = (scopeNode) => {
    const cur = scopeNode?.querySelector(".kprice__current .klik-riyal-amount, .klik-riyal-amount");
    const amount = (cur?.textContent || "").trim();
    if (!amount) return "";
    let pct = 0;
    try { pct = Number(JSON.parse(scopeNode.closest("[data-kprice-signature]")?.dataset.kpriceSignature || scopeNode.querySelector("[data-kprice-signature]")?.dataset.kpriceSignature || "[]")[0]?.percent) || 0; } catch (e) {}
    return t(`${amount} riyals`, `${amount} ريال`) + (pct > 0 ? t(`, ${pct}% off applied`, `، بعد خصم ${pct}٪`) : "");
  };
  function makeItYours(box, scope) {
    const cta = box.querySelector(".kpdp-cta");
    if (!cta || cta.dataset.kpdpBound) return;
    cta.dataset.kpdpBound = "1";
    const isReady = cta.dataset.kind === "ready" || ready();
    const isRoom = !!box.closest(".kl-pdp-panel") || !!scope.querySelector?.(".kl-pdp-price");
    // refine 2026-10-22: finish vs fabric from the family (furniture studio, product type, handle), never from the h1
    const finish =
      (!!document.querySelector("[data-furniture-open], [data-kfp]") ||
        /wardrobe|dresser|cabinet|sideboard|(^|\s)table$|دولاب|خزانة|تسريحة|طاولة/i.test(String(window.ShopifyAnalytics?.meta?.product?.type || "").trim()) ||
        /\/products\/[^/?#]*(coffee-table|side-table|console|wardrobe|dresser|cabinet|sideboard)/i.test(location.pathname)) &&
      !upholstered();
    const line = cta.querySelector(".kpdp-cta-asshown");
    // p4-cta-2 (server, klik-pdp-actions): the pictured fabric by its type ("woven & jacquard fabrics"; never the library
    // colour group, CONFIGURATOR-PLAN 2.8) and a piece in the photo that is not part of the order (Hazel's pouf)
    const picFabric = line?.dataset.kpdpPicFabric || "";
    const extra = line?.dataset.kpdpExtra === "pouf" ? t("pouf shown not included", "البوف الظاهر غير مشمول") : "";
    // a single furniture piece is sized by its dimensions ("65 × 55 × 45 cm"), not "One complete piece"
    const dims0 = (() => {
      for (const n of document.querySelectorAll(".kpe-facts-line")) {
        const m = n.textContent.match(/:\s*([\d.,]+\s*[×x]\s*[\d.,]+\s*[×x]\s*[\d.,]+\s*(?:cm|سم))/);
        if (m) return m[1].replace(/\s*x\s*/g, " × ");
      }
      return "";
    })();
    const lead = line?.querySelector(".kpdp-cta-asshown__lead");
    const value = line?.querySelector(".kpdp-cta-asshown__value");
    const reset = line?.querySelector(".kpdp-cta-reset");
    const add = cta.querySelector(".kpdp-cta-add");
    const addLabel = add?.querySelector(".kpdp-cta-add__label");
    const addSub = add?.querySelector(".kpdp-cta-add__sub");
    const addPrice = add?.querySelector(".kpdp-cta-add__price");
    // p4-cta: ONE primary on studio families ("Design it in 3D · from ⃁price" + the reassurance line); the as-pictured
    // line and the Add live in the studio's first view ("Buy as pictured · ⃁price", after a change "Add to cart · ⃁new")
    const one = cta.classList.contains("kpdp-cta--studio") && !!cta.querySelector(".kpdp-cta-3d--primary");
    const main = one ? cta.querySelector(".kpdp-cta-3d--primary") : null;
    const mainTitle = main?.querySelector(".kpdp-cta-3d__title");
    const mainPrice = main?.querySelector(".kpdp-cta-3d__price");
    const mainFrom = main?.querySelector(".kpdp-cta-3d__from");
    const mainAmount = main?.querySelector(".kpdp-cta-3d__amount");
    const note = one ? cta.querySelector(".kpdp-cta-note") : null;
    /* pdpm-build (2026-10-22): the one button's own second line says what the tap offers ("Buy as pictured, or change size
       & fabric"), so the note under it is empty by default (it only says "Your design: …" after a change) and the price
       line inside the button shows only when the price is the news (a studio change, a furniture chip) or where no first
       view opens (room builders, edit links: the studio opens directly, "from ⃁price" as before). */
    const mainSub = main?.querySelector(".kpdp-cta-3d__sub");
    const subOk = !!mainSub && !fvBuilder() && !fvLink();
    if (mainSub && !subOk) mainSub.hidden = true;
    let mainTitle0 = "";
    let note0 = "";
    if (note && fvDirect()) {
      if (fvBuilder()) ((note.textContent = t("Next: choose your pieces, sizes and finishes", "الخطوة التالية: اختر القطع والمقاسات والتشطيبات")), (note0 = note.innerHTML), (note.hidden = false));
      else note.hidden = true;
    }
    // p4-cta-2: the room builders' one label, the same in both languages (the room script and this paint raced: EN kept
    // "Build my bedroom in 3D", AR went back to «صمّم طلبك بتقنية 3D»)
    if (mainTitle && fvBuilder())
      mainTitle0 = kind() === "dining" || /dining/i.test(location.pathname) ? t("Build my dining set in 3D", "صمّم طقم سفرتي بتقنية <bdi>3D</bdi>") : t("Build my bedroom in 3D", "صمّم غرفة نومي بتقنية <bdi>3D</bdi>");
    // refine: no generic library swatches next to "As pictured" (they read as a choice); the dots stay empty (hidden)
    // the product's own wording for the pictured size, read once (the price label later reads "Your configuration")
    let label0Cache = "";
    const label0 = () =>
      label0Cache ||
      (label0Cache = tidy(
        (scope.querySelector(".kp6-price-label, .kl-pdp-price__scope")?.textContent || "")
          .split(/\s+·\s+/)
          .map((s) => plain(s))
          // (p4-cta-2: a part with a number is a size, never noise: «جلسة بطول إجمالي 4.54 م» was dropped for «إجمالي»)
          .filter((s) => s && (/\d/.test(s) || !NOISE.test(s)) && !/your configuration|your design|configuration price|price|تصميمك|اختياراتك|سعر|السعر/i.test(s))
          .join(" · "),
      ));
    const rows = () => [...(box.querySelector(".kflow-overview")?.querySelectorAll(":scope > div") || [])];
    const editing = new URLSearchParams(location.search).has("klik-edit");
    const restored = () => !!document.querySelector("[data-klik-design-restored='true']");
    /* refine 2026-10-22 (critic HIGH): "as pictured" is the first configuration the studio reports for its default design
       (the overview rows fill only once the studio has built it), not the empty rows before the first visit. Until the
       shopper makes a real choice (a trusted input or option tap inside a studio or the furniture chips), every reported
       state is the pictured one; afterwards a part that was empty is still filled in, and only a different value counts
       as a change. A design restored from a saved one, or an edit from the cart, is "Your design" from the start. */
    let touched = false;
    const pic = { size: "", fabric: "" };
    const SURFACE = "[data-klik-dpo-wizard], [id^='KlikDpoWizard-'], dialog, [aria-modal='true'], .kz-on, [data-kfp], [data-furniture-studio], .kr-studio";
    const OPTION = "input, select, textarea, label, [role='radio'], [role='option'], [role='checkbox'], [role='slider'], [aria-pressed], [aria-checked], [data-value], [data-kfp-size], [data-kfp-finish]";
    const onInput = (e) => {
      if (!e.isTrusted || touched) return;
      const el = e.target;
      if (!el?.closest || el.closest(".kpdp-cta, .kpdp-bar")) return;
      if (!el.closest(SURFACE)) return;
      if (e.type === "click" && !el.closest(OPTION)) return;
      touched = true;
    };
    for (const type of ["change", "input", "click"]) document.addEventListener(type, onInput, { capture: true, passive: true });
    // furniture: the size and finish chips (furniture-catalog-studio.js) are part of the same state
    const kfp = () => document.querySelector("[data-kfp]:not([hidden])");
    let kfpPic = null;
    const kfpState = () => {
      const k = kfp();
      if (!k) return null;
      const chip = k.querySelector("[data-kfp-size][aria-checked='true']");
      const fin = k.querySelector("[data-kfp-finish][aria-checked='true']");
      const name = (chip?.querySelector("[data-kfp-name]")?.textContent || "").trim();
      const dims = (chip?.querySelector("[data-kfp-dims]")?.textContent || "").trim();
      return {
        sizeId: chip?.dataset.kfpSize || "",
        finishId: fin?.dataset.kfpFinish || "",
        size: [name, dims].filter(Boolean).join(" · "),
        fabric: (fin?.getAttribute("aria-label") || k.querySelector("[data-kfp-finish-name]")?.textContent || "").trim(),
        price: chip?.querySelector(".kfp-chip__price")?.innerHTML || "",
      };
    };
    const totalNode = () => scope.querySelector(".kp6-total, .kl-pdp-price [data-total]");
    const adapter = () => !!window.KlikOrderAsShown?.get?.();
    let lastChipPrice = "";
    let studioChanged = false;
    let chipChanged = false;
    let link3d = null;
    /* p5-cfg-entry A3 (KD-2): "changed" comes from data, never from names. The design is changed when the selected
       fabric key is not the original one (the studio's library, per piece on sofa sets), an extra is added (tables; the
       corner side or the pouf from the first view), or, after the shopper touched the studio, the klik:dpo-state amount
       differs from the pictured one by ⃁1 or more. The overview text compare stays as one more signal.
       A4 (KZ-03): one price for "as pictured": the first complete pictured klik:dpo-state (what the cart charges) prices
       the buy box, the one button, the first view, the instalments and the bar (through KlikPricePresentation.render on
       the buy-box total, so every mirror follows); a gap above ⃁1 against the server price is published once. While the
       buy box still shows the server estimate, a changed design's latest complete amount is shown the same way. */
    const wiz = () => document.querySelector("[data-klik-dpo-wizard]");
    const SET_LABEL = /^\s*(?:Set total|إجمالي الطقم)\s*$/;
    const cfg = { key: "original", item: null, dpo: 0, set: false, pic: 0, shown: 0, mismatch: false, data: false, at: 0, extras: {} };
    const server0 = Number(totalNode()?.dataset.kpriceBase || totalNode()?.querySelector?.("[data-kprice-base]")?.dataset.kpriceBase) || 0;
    const readData = () => {
      cfg.at = performance.now();
      try {
        const l = wiz()?.klikFabricLibrary?.list?.();
        if (Array.isArray(l) && l.length) {
          const sel = l.find((x) => x.selected);
          if (sel) ((cfg.key = String(sel.key || "")), (cfg.item = sel));
        }
      } catch (e) {}
      let pieces = false;
      try {
        const ps = window.sofaSet?.pieces;
        // (a piece shown in its photo fabric carries the original / photoChoice flag, or a pseudo SKU such as KLIK-ZON-CHAIR-PHOTO)
        if (Array.isArray(ps)) pieces = ps.some((p) => { const f = p?.previewState?.fabric; return !!f && !(f.original || f.photoChoice || /PHOTO/i.test(String(f.sku || ""))); });
      } catch (e) {}
      let tables = false;
      try { tables = JSON.parse(wiz()?.dataset.klikTables || "[]").length > 0; } catch (e) {}
      cfg.data = (!!cfg.key && cfg.key !== "original") || pieces || tables || Object.values(cfg.extras).some((x) => x && x.changed);
      return cfg.data;
    };
    const amountChanged = () => !!(cfg.pic && cfg.dpo && Math.abs(cfg.dpo - cfg.pic) >= 100 && (touched || cfg.data));
    const showPrice = () => {
      const want = cfg.data || amountChanged() ? cfg.dpo : cfg.pic;
      if (!(want > 0) || want === cfg.shown || scope.dataset.priceState !== "estimate") return;
      const host = totalNode();
      const h = host?.matches?.("[data-kprice-base]") ? host : host?.querySelector?.("[data-kprice-base]");
      if (!h) return;
      if (Number(h.dataset.kpriceBase) === want) return void (cfg.shown = want);
      try {
        if (window.KlikPricePresentation?.render?.(h, want, { compareAt: 0, quantity: Number(h.dataset.kpriceQuantity) || 1, compact: h.dataset.kpriceCompact === "true", estimate: false, mode: h.dataset.kpriceMode === "exact" ? "exact" : undefined })) cfg.shown = want;
      } catch (e) {}
    };
    let commitT = 0;
    const commit = () => {
      // a sofa set prices piece by piece while it is (re)built: wait for the whole set
      if (window.sofaSet?.busy) return void (commitT = setTimeout(commit, 400));
      readData();
      const fresh = !touched && !editing && !restored() && !cfg.data;
      // (a part of a set is never the pictured set: within 20 % of the server price; KZ-03 gaps are about 1 %)
      if (fresh && !cfg.pic && cfg.dpo && (!server0 || Math.abs(cfg.dpo - server0) <= server0 * 0.2)) {
        cfg.pic = cfg.dpo;
        if (server0 && Math.abs(cfg.pic - server0) > 100 && !cfg.mismatch) ((cfg.mismatch = true), publish("klik_price_mismatch", { server: server0, dpo: cfg.pic }));
      }
      showPrice();
      schedule();
    };
    document.addEventListener("klik:dpo-state", (e) => {
      const d = e.detail || {};
      if (d.productId && String(d.productId) !== productId()) return;
      if (SET_LABEL.test(d.label || "")) cfg.set = true;
      if (!d.complete || d.estimated || d.quoteRequired) return;
      const cents = Math.round(Number(d.amount) * 100);
      if (!(cents > 0) || (cfg.set && !SET_LABEL.test(d.label || ""))) return;
      cfg.dpo = cents;
      clearTimeout(commitT);
      commitT = setTimeout(commit, 600);
    });
    // A9 (KZ-11): a shared design link is opening (area C sets [data-klik-shared-opening] until it is restored): the one
    // button and the bar say so and offer neither the first view nor the pictured price
    const loadAt = Date.now();
    const sharedOpening = () => !!document.querySelector("[data-klik-shared-opening]") || (/klik-(config|design)=/.test(location.hash) && !restored() && Date.now() - loadAt < 30000);
    // the first view's own extras (klik-pdp-plus: the corner side, the pouf in the photo) join the same state
    cta.__kpdpExtra = (key, value) => {
      cfg.extras[key] = value || null;
      readData();
      clearTimeout(commitT);
      commitT = setTimeout(commit, 50);
      // painted in the tap's own task, so the next frame shows it even when warm-up work is queued behind the tap
      try { paint(); } catch (e) { schedule(); }
    };
    cta.__kpdpCfg = () => ({ key: cfg.key, item: cfg.item, dpo: cfg.dpo, pic: cfg.pic, data: cfg.data, changed: cta.dataset.state === "changed", extras: Object.assign({}, cfg.extras) });
    const paint = () => {
      const [sizeRow, fabricRow] = rows();
      let size = sizeRow && !sizeRow.hidden ? tidy(plain(sizeRow.querySelector("dd")?.textContent)) : "";
      let fabric = fabricRow && !fabricRow.hidden ? tidy(plain(fabricRow.querySelector("dd")?.textContent)) : "";
      if (isRoom && fabric) fabric = fabric.split(/\s+·\s+/)[0]; // rooms: size + one material
      // p4-cta-2: dining sets as pictured name the set by its size, in both languages (the room summary's first material
      // mixed the chair colour with the table top: "Off-white glass"; the Arabic size row had no dimensions)
      const diningPic = isRoom && kind() === "dining";
      if (diningPic && size && !/\d+\s*×\s*\d+/.test(size)) {
        const m = (scope.querySelector(".kl-set__list li")?.textContent || "").match(/(\d+(?:\.\d+)?)\s*×\s*(\d+(?:\.\d+)?)\s*×\s*\d+(?:\.\d+)?\s*(cm|سم)/);
        if (m) size = `${size} · ${m[1]} × ${m[2]} ${m[3]}`;
      }
      let sizeChanged = false;
      let fabricChanged = false;
      if (size) {
        if (!pic.size || !touched) pic.size = size;
        else sizeChanged = size !== pic.size;
      }
      if (fabric) {
        if (!pic.fabric || !touched) pic.fabric = fabric;
        else fabricChanged = fabric !== pic.fabric;
      }
      if (!isReady && performance.now() - cfg.at > 400) readData();
      // A3: a fabric chosen from the library shows by its name even before the studio filled the overview rows
      if (!isReady && cfg.key && cfg.key !== "original" && cfg.item && !fabric) fabric = tidy(plain(niceFabric(cfg.item)));
      const extraLines = Object.values(cfg.extras).filter((x) => x && x.changed && x.line).map((x) => x.line);
      studioChanged = !isReady && (sizeChanged || fabricChanged || cfg.data || amountChanged() || ((editing || restored()) && !!(size || fabric)));
      // furniture chips
      const ks = !isReady ? kfpState() : null;
      chipChanged = false;
      if (ks) {
        if (!kfpPic) kfpPic = { sizeId: ks.sizeId, finishId: ks.finishId };
        if (!kfpPic.finishId) kfpPic.finishId = ks.finishId;
        chipChanged = (!!ks.sizeId && ks.sizeId !== kfpPic.sizeId) || (!!ks.finishId && !!kfpPic.finishId && ks.finishId !== kfpPic.finishId);
        // p4-cta-2: the chip's finish name goes through the same code stripping ("… KF-1112-10")
        if (!studioChanged) ((size = ks.size || size), (fabric = tidy(plain(ks.fabric)) || fabric));
      }
      const changed = studioChanged || chipChanged;
      const state = changed ? "changed" : "default";
      if (cta.dataset.state !== state) cta.dataset.state = state;
      if (line) {
        if (line.dataset.state !== state) line.dataset.state = state;
        // one naming scheme before and after the studio: the pictured size keeps the product's own wording
        // (p4-cta-2: a single piece without size chips is named by its dimensions)
        const l0 = dims0 && !ks?.sizeId && (!label0() || /complete piece|one piece|القطعة كاملة|قطعة واحدة/i.test(label0())) ? dims0 : label0();
        const sizeText = (!changed && !ks?.sizeId && !isRoom && l0) || size || l0 || t("Size as pictured", "المقاس كما في الصورة");
        // p4-cta-2: the pictured fabric keeps its server name (its type) while the shopper has not changed the fabric
        const fabricText = picFabric && !fabricChanged && !chipChanged && !(cfg.key && cfg.key !== "original") ? picFabric : fabric ? niceFabric(fabric) : picFabric || (finish ? t("finish as pictured", "التشطيب كما في الصورة") : t("fabric as pictured", "القماش كما في الصورة"));
        const dropFabric = diningPic && !changed && !!size;
        // p4-cta: nothing known yet about either part (hazel before its studio reports): one plain phrase, not
        // "size as pictured · fabric as pictured"
        const parts = !size && !l0 && !fabric && !picFabric ? [finish ? t("the size and finish in the photo", "المقاس والتشطيب الظاهران في الصورة") : t("the size and fabric in the photo", "المقاس والقماش الظاهران في الصورة")] : dropFabric ? [sizeText] : [sizeText, fabricText];
        if (extra && !changed && !cfg.extras.pouf?.changed) parts.push(extra);
        // A7 / A14: the corner side and the pouf chosen in the first view (klik-pdp-plus)
        // ("L-shape · corner left · 300 + 200 cm": the side follows the shape when the size names one)
        if (extraLines.length) {
          const m = /^((?:L-shape|U-shape|Chaise|شكل L|شكل U|شيزلونج)[^·]*?)\s*·\s*(.+)$/.exec(parts[0] || "");
          m ? parts.splice(0, 1, m[1], ...extraLines, m[2]) : parts.splice(1, 0, ...extraLines);
        }
        const html = parts.map(bidi).join(' <span class="kpdp-sep">·</span> ');
        if (value && value.innerHTML !== html) value.innerHTML = html;
        const leadText = changed ? t("Your design:", "تصميمك:") : t("As pictured:", "كما في الصورة:");
        if (lead && lead.textContent !== leadText) lead.textContent = leadText;
        if (reset && reset.hidden === changed) reset.hidden = !changed;
      }
      if (addLabel && add.dataset.state !== "loading" && add.dataset.state !== "error") {
        // honest label: without a family adapter the tap opens the studio's review step (one Add there)
        const direct = isReady || adapter();
        // p4-cta: in the studio's first view the pictured design is "Buy as pictured"; after a change "Add to cart"
        const text = !direct ? t("Review & add", "راجع وأضف للسلة") : one && !changed ? t("Buy as pictured", "اشترِ كما في الصورة") : t("Add to cart", "أضف إلى السلة");
        if (addLabel.textContent !== text) addLabel.textContent = text;
        if (addSub) {
          const sub = t("as pictured", "كما في الصورة");
          if (addSub.textContent !== sub) addSub.textContent = sub;
          if (addSub.hidden !== changed) addSub.hidden = changed;
        }
        // p4-cta-2: one spoken name ("Buy as pictured, 3,188.17 riyals, 10% off applied")
        const sp = spokenPrice(totalNode());
        const al = sp ? `${text}${addSub && !addSub.hidden ? " " + addSub.textContent : ""}${t(", ", "، ")}${sp}` : "";
        if ((add.getAttribute("aria-label") || "") !== al) al ? add.setAttribute("aria-label", al) : add.removeAttribute("aria-label");
      }
      // the price inside the button = the buy-box total (classic: .kprice__current; rooms: the [data-total] amount);
      // furniture: a size chip carries its own price, mirrored to the total and the button
      const total = totalNode();
      if (ks && ks.price && !studioChanged && (chipChanged || lastChipPrice) && lastChipPrice !== ks.price) {
        lastChipPrice = ks.price;
        // cta2-fix2: the chip's variant price goes through KlikPricePresentation.render, so the total keeps the kprice
        // markup (data-kprice-current, the campaign badge, the struck-out price) and the pay-in-4 line and the sticky bar
        // follow it (render queues the BNPL sync). The chip markup copy below stays only as a fallback.
        const host = total?.matches?.("[data-kprice-base]") ? total : total?.querySelector("[data-kprice-base]");
        const variant = (window.ShopifyAnalytics?.meta?.product?.variants || []).find((x) => String(x.id) === String(ks.sizeId));
        const cents = Math.round(Number(variant?.price));
        const cmp = Number(host?.dataset.kpriceCompare) || 0;
        const rendered = !!(host && cents > 0 && window.KlikPricePresentation?.render?.(host, cents, { compareAt: cmp > cents ? cmp : 0, quantity: Number(host.dataset.kpriceQuantity) || 1, compact: host.dataset.kpriceCompact === "true", estimate: host.dataset.kpriceEstimate === "true", mode: host.dataset.kpriceMode === "exact" ? "exact" : undefined }));
        const cur = rendered ? null : total?.querySelector(".kprice") || total;
        if (cur) {
          const tmp = document.createElement("div");
          tmp.innerHTML = ks.price;
          const next = tmp.querySelector(".kprice");
          if (next && cur.classList.contains("kprice")) cur.replaceWith(next);
          else cur.innerHTML = ks.price;
        }
      }
      if (addPrice) {
        const cur = total?.querySelector(".kprice__current");
        const html = cur ? cur.innerHTML : total ? (/\d/.test(total.textContent) ? esc(total.textContent.trim()) : "") : addPrice.innerHTML;
        if (addPrice.innerHTML !== html) addPrice.innerHTML = html;
        if (addPrice.hidden !== !html) addPrice.hidden = !html;
      }
      // p4-cta: the one primary mirrors the same total ("from" while it is the pictured design), and the line under it
      // says what the first view offers ("Or buy it exactly as pictured inside"; after a change "Your design: …")
      if (main) {
        // (a tap kept before the scripts ran shows "Opening…" in CSS only, so the title read here is always the real one)
        if (!mainTitle0 && mainTitle) mainTitle0 = mainTitle.innerHTML;
        const cur = total?.querySelector(".kprice__current");
        // p5-cfg-entry A6: a saved design on this device ("Continue your design · ⃁saved total", the price only when one
        // was saved); A9: a shared design that is opening shows no price and no second line until it is restored
        const savedNow = !studioChanged && !chipChanged && main.dataset.kpdpShared !== "1" && cta.__kpdpSaved ? cta.__kpdpSaved() : null;
        const savedC = savedNow && Number(savedNow.cents) > 0 ? Math.round(window.KlikPricePresentation?.price?.(Number(savedNow.cents))?.current || Number(savedNow.cents)) : 0;
        const html = savedNow ? (savedC ? riyal(savedC) : "") : cur ? cur.innerHTML : total && /\d/.test(total.textContent) ? esc(total.textContent.trim()) : mainAmount?.innerHTML || "";
        if (mainAmount && html && mainAmount.innerHTML !== html) mainAmount.innerHTML = html;
        const quiet = main.dataset.kpdpShared === "1";
        const showPrice = !quiet && !!html && !!(mainAmount?.innerHTML || "").trim() && (changed || !!savedNow || !subOk);
        if (mainPrice && mainPrice.hidden === showPrice) mainPrice.hidden = !showPrice;
        const subOff = changed || !!savedNow || quiet;
        if (mainSub && subOk && mainSub.hidden !== subOff) mainSub.hidden = subOff;
        if (mainFrom && mainFrom.hidden !== (changed || !!savedNow)) mainFrom.hidden = changed || !!savedNow;
        /* p4-cta-2 (PACKAGES §1.13b): furniture with on-page size chips and finish swatches. Once the shopper picked a chip
           in the buy box, the page already holds the decision: the one button adds that choice directly ("Add to cart ·
           ⃁new price", the family adapter with Astra inside), and the 3D path stays as one quiet link under it. Before any
           chip tap it is the owner's one button ("Design it in 3D", Buy as pictured inside). */
        const direct = chipChanged && !studioChanged && adapter();
        if ((cta.dataset.kpdpDirect === "1") !== direct) cta.dataset.kpdpDirect = direct ? "1" : "";
        const busyMain = /^(loading|error)$/.test(main.dataset.state || "");
        const opening = sharedOpening();
        if (opening !== (main.dataset.kpdpShared === "1")) {
          if (opening) ((main.dataset.kpdpShared = "1"), main.setAttribute("aria-busy", "true"));
          else (delete main.dataset.kpdpShared, main.dataset.kpdpOpening || main.removeAttribute("aria-busy"));
        }
        const saved = !direct && !opening ? savedNow : null;
        const titleHtml = opening ? esc(t("Shared design · opening…", "تصميم مُشارك · جارٍ الفتح…")) : studioChanged || saved ? esc(t("Continue your design", "أكمل تصميمك")) : direct ? esc(t("Add to cart", "أضف إلى السلة")) : mainTitle0;
        if (!busyMain && mainTitle && titleHtml && mainTitle.innerHTML !== titleHtml) mainTitle.innerHTML = titleHtml;
        if (!busyMain && main.dataset.state !== "success" && main.dataset.state !== state) main.dataset.state = state;
        const iconNode = main.querySelector(".kpdp-cta-3d__icon");
        if (iconNode && (iconNode.dataset.icon || "cube") !== (direct ? "cart" : "cube")) {
          if (!iconNode.__kpdpCube) iconNode.__kpdpCube = iconNode.innerHTML;
          iconNode.innerHTML = direct ? CART : iconNode.__kpdpCube;
          iconNode.dataset.icon = direct ? "cart" : "cube";
        }
        if (direct && !link3d) {
          link3d = make("button", "kpdp-cta-3dlink", `<span class="kpdp-ico" aria-hidden="true">${ICON.cube}</span><span>${t("Or customise it in 3D", "أو خصّصه بتقنية <bdi>3D</bdi>")}</span>`);
          link3d.type = "button";
          link3d.addEventListener("click", () => {
            publish("klik_pdp_design_3d_selected", { source: "chips" });
            if (!window.KlikStudioFirstView?.open?.(main)) try { main.__kpdpOpen?.(); } catch (e) {}
          });
          (note || main).after(link3d);
        }
        if (link3d && link3d.hidden === direct) link3d.hidden = !direct;
        // p4-cta-2: one spoken name ("Design it in 3D, from 3,188.17 riyals, 10% off applied")
        const sp = spokenPrice(total);
        const name = opening ? t("Shared design · opening…", "تصميم مُشارك · جارٍ الفتح…") : studioChanged || saved ? t("Continue your design", "أكمل تصميمك") : direct ? t("Add to cart", "أضف إلى السلة") : (mainTitle?.textContent || "").replace(/\s+/g, " ").trim();
        const subText = mainSub && !mainSub.hidden ? (mainSub.textContent || "").replace(/\s+/g, " ").trim() : "";
        const al = sp && !busyMain ? `${name}${t(", ", "، ")}${changed ? "" : t("from ", "من ")}${sp}${subText ? ". " + subText : ""}` : "";
        if ((main.getAttribute("aria-label") || "") !== al) al ? main.setAttribute("aria-label", al) : main.removeAttribute("aria-label");
        if (note) {
          const noteHtml = changed && value ? `<b>${esc(t("Your design:", "تصميمك:"))}</b> ${value.innerHTML}` : note0;
          if (note.innerHTML !== noteHtml) note.innerHTML = noteHtml;
          if (note.hidden !== !noteHtml) note.hidden = !noteHtml;
          if (note.dataset.state !== state) note.dataset.state = state;
        }
      }
      try { cta.__kpdpFvPaint?.(); } catch (e) {}
    };
    let queued = false;
    const schedule = () => queued || ((queued = true), requestAnimationFrame(() => ((queued = false), paint())));
    paint();
    const list = box.querySelector(".kflow-overview");
    if (list) new MutationObserver(schedule).observe(list, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ["hidden"] });
    const total = totalNode();
    if (total) new MutationObserver(schedule).observe(total, { childList: true, subtree: true, characterData: true });
    document.addEventListener("klik:dpo-state", schedule);
    document.addEventListener("klik:order-as-shown-ready", schedule);
    // A9: the shared-design flag and the restore mark come and go on the page root and the studio root only
    for (const node of [box.closest("[data-kpd-page]"), wiz()].filter(Boolean))
      new MutationObserver(schedule).observe(node, { attributes: true, attributeFilter: ["data-klik-shared-opening", "data-klik-design-restored"] });
    window.addEventListener("load", () => setTimeout(schedule, 50), { once: true });
    // the furniture chips and swatches (their own handler runs first; the state is read on the next frame)
    document.addEventListener("click", (e) => e.target.closest?.("[data-kfp-size], [data-kfp-finish]") && setTimeout(schedule, 0), { passive: true });
    const kfpNode = document.querySelector("[data-kfp]");
    if (kfpNode) new MutationObserver(schedule).observe(kfpNode, { attributes: true, subtree: true, childList: true, attributeFilter: ["hidden", "aria-checked"] });
    // "Back to as pictured": the chips go back to the pictured ones; a studio design reloads the page, which opens on the
    // pictured design (a saved design is kept under a backup key, never lost)
    reset?.addEventListener("click", () => {
      publish("klik_pdp_back_to_pictured");
      if (!studioChanged && chipChanged && kfpPic) {
        const k = kfp();
        if (kfpPic.sizeId) k?.querySelector(`[data-kfp-size="${CSS.escape(kfpPic.sizeId)}"]`)?.click();
        if (kfpPic.finishId) k?.querySelector(`[data-kfp-finish="${CSS.escape(kfpPic.finishId)}"]`)?.click();
        setTimeout(schedule, 0);
        return;
      }
      // p5-cfg-entry A3: the first view's own extras (side, pouf) reset in place
      for (const k of Object.keys(cfg.extras)) if (cfg.extras[k]?.reset) try { cfg.extras[k].reset(); } catch (e) {}
      try {
        const keyName = "klik-dpo-design-" + productId();
        const saved = localStorage.getItem(keyName);
        if (saved) (localStorage.setItem(keyName + "-before-reset", saved), localStorage.removeItem(keyName));
      } catch (e) {}
      const url = new URL(location.href);
      [...url.searchParams.keys()].filter((k) => /^klik[-_]/.test(k)).forEach((k) => url.searchParams.delete(k));
      url.hash = "";
      location.assign(url.toString());
    });
    // a long add says what is happening ("Preparing your order…" after 2.5 s)
    // (p5-cfg-entry A5: the long add keeps ONE label, "Adding to cart…"; the steps run in its quiet second line, tryAdd)
    if (add)
      for (const type of ["pointerdown", "keydown"])
        add.addEventListener(type, (e) => {
          // the pressed state shows at once, before the tap's click handlers run (≤ 100 ms on a busy phone)
          if (type === "keydown" && e.key !== "Enter" && e.key !== " ") return;
          add.dataset.pressed = "1";
          clearTimeout(add.__kpdpPress);
          add.__kpdpPress = setTimeout(() => delete add.dataset.pressed, 700);
        }, { passive: true });
    // success tick on every path (also when the studio's own Add finished the order): klik-cart-added.js event
    document.addEventListener("klik:cart-added", () => {
      if (!add || add.dataset.state === "loading") return;
      add.dataset.state = "success";
      setTimeout(() => add.dataset.state === "success" && (add.dataset.state = "idle"), 2200);
    });
  }
  /* ---------- p4-cta (owner 2026-10-22 08:00 PT): "Make purchase button 1 which is design in 3D with an option inside for
     customer to just buy as is." Studio families have ONE primary, "Design it in 3D · from ⃁price". The tap opens the
     studio's first view at once (div.kpdp-fv, pure page markup, nothing heavy on the tap): the pictured photo, the
     as-pictured line and the two ways on: "Customise size & fabric" (starts the studio steps; the studio has been
     warming since the finger touched the button) and "Buy as pictured · ⃁price" (the family adapter's add, Astra capture
     and DPO validation inside it, after this tap → KlikCartAdded, main item first). After a change the first view says
     "Your design" and the button "Add to cart · ⃁new price". Deep links (?studio=1, ?klik-edit=, shared designs) and the
     room builders open the studio straight away.
     p4-cta-2: not a modal <dialog>. showModal() makes the whole page inert, one style pass over 12–15k nodes (tv 271–448 ms,
     sira AR 306–861 ms at CPU x4, qa/p4-critic/modal.txt) before the first view could paint. It is a fixed overlay
     (div[role=dialog], aria-modal while open) built and laid out at idle after load, invisible until the tap sets
     data-kpdp-fv-open in its own task;
     focus trap, Escape, the backdrop and Back are ours (history unchanged). Under "Buy as pictured" it now carries what the
     buy box sells with: the struck price and the offer, the instalments line (the page's own Tabby/Tamara marks) and the
     lead time. ---------- */
  /* p5-cfg-entry A2 (KZ-02, KD-1): the studio warms while the shopper reads. The first touch of the one button or the
     bar (the inline keeper sends it first, window capture) and the first view's open are the intent: klik:studio-intent
     (the workspace loads its modules on it), then warmStudio's own preparation (DPO's options form, config only, never
     ValidateForm; the studio script; the pictured design; the model) in the shopper's reading pauses, after the first
     view painted. Skipped with Data Saver and on 2G (warmStudio never registers there). */
  const intents = (window.__kpdpIntent = window.__kpdpIntent || {});
  let warmHook = null;
  // A12 (H6): tables (klik-furniture, not upholstered) get the 1.2 MB of fabric names and library only on the first intent
  const lazyFabricJs = () => {
    const tags = [...document.querySelectorAll("script[type='text/plain'][data-klik-lazy-src]")];
    for (const tag of tags) {
      const sc = document.createElement("script");
      sc.src = tag.dataset.klikLazySrc;
      sc.async = false;
      tag.replaceWith(sc);
    }
  };
  const studioIntent = (source) => {
    lazyFabricJs();
    loadPlus();
    if (!intents[source]) {
      intents[source] = 1;
      try { document.dispatchEvent(new CustomEvent("klik:studio-intent", { detail: { productId: productId(), family: familyOf(), source } })); } catch (e) {}
    }
    try { warmHook?.(source); } catch (e) {}
  };
  for (const type of ["pointerdown", "keydown"])
    addEventListener(type, (e) => {
      const b = e.target?.closest?.(".kpdp-cta-3d--primary, .kpdp-bar-buy--3d, .kpdp-fv__customise, [data-kfp-size], [data-kfp-finish], [data-furniture-open]");
      if (!b || (type === "keydown" && e.key !== "Enter" && e.key !== " ")) return;
      studioIntent(b.classList.contains("kpdp-bar-buy--3d") ? "bar" : b.classList.contains("kpdp-fv__customise") ? "first-view" : "button");
    }, { capture: true, passive: true });
  /* the first view's additions (klik-pdp-plus.js: the saved design, the corner side, proof and help, the delivery date,
     starters) load in idle time after load, or at the first intent; this file keeps the core (open, add, prices) */
  const PLUS_V = "p5e1";
  function loadPlus() {
    if (window.__kpdpPlusLoading || !document.querySelector(".kpdp-cta--studio .kpdp-cta-3d--primary")) return;
    // the server prints the content-hashed address (klik-pdp-actions data-kpdp-plus); else this file's folder + PLUS_V
    const own = document.querySelector("[data-kpdp-plus]")?.dataset.kpdpPlus || "";
    const base = own ? "" : assetBase();
    if (!own && !base) return;
    window.__kpdpPlusLoading = 1;
    const sc = document.createElement("script");
    const qv = new URLSearchParams(location.search).get("kpdpv");
    sc.src = own && !qv ? own : (own ? own.split("?")[0] : base + "klik-pdp-plus.js") + "?v=" + (qv || PLUS_V);
    sc.defer = true;
    document.head.append(sc);
  }
  function firstView(box, scope) {
    const cta = box.querySelector(".kpdp-cta--studio");
    const main = cta?.querySelector(".kpdp-cta-3d--primary");
    const inside = cta?.querySelector("[data-kpdp-inside]");
    const line = inside?.querySelector(".kpdp-cta-asshown");
    const add = inside?.querySelector(".kpdp-cta-add");
    if (!cta || !main || !add || cta.dataset.kpdpFv) return;
    cta.dataset.kpdpFv = "1";
    const isRoom = !!box.closest(".kl-pdp-panel");
    const finish =
      (!!document.querySelector("[data-furniture-open], [data-kfp], [data-furniture-configurator]") ||
        /\/products\/[^/?#]*(coffee-table|side-table|console|wardrobe|dresser|cabinet|sideboard)/i.test(location.pathname)) &&
      !upholstered();
    const skip = () => !productId() || fvDirect();
    const X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" focusable="false" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
    const GO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" focusable="false"><path d="m9 6 6 6-6 6"/></svg>';
    const copy = {
      kind: isRoom ? t("Made to order · sizes & finishes", "تفصيل حسب الطلب · مقاساتك وتشطيباتك") : finish ? t("Made to order · your size & finish", "تفصيل حسب الطلب · مقاسك وتشطيبك") : t("Made to order · your size & fabric", "تفصيل حسب الطلب · مقاسك وقماشك"),
      ask: t("How would you like it?", "كيف تريد طلبك؟"),
      yours: t("Your design", "تصميمك"),
      custom: isRoom ? t("Customise pieces & finishes", "خصّص القطع والتشطيبات") : finish ? t("Customise size & finish", "خصّص المقاس والتشطيب") : t("Customise size & fabric", "خصّص المقاس والقماش"),
      edit: t("Edit your design", "عدّل تصميمك"),
      sub: isRoom ? t("Live 3D · live price", "معاينة <bdi>3D</bdi> · سعر مباشر") : finish ? t("Live 3D · more sizes & finishes", "معاينة <bdi>3D</bdi> · مقاسات وتشطيبات أكثر") : t("Live 3D · live price · extras", "معاينة <bdi>3D</bdi> · سعر مباشر · إضافات"),
      // p4-cta-2: the studio's state lives in the card's sub-line, never as a chip on the photo (it read as "this photo is 3D")
      subReady: t("Live 3D ready · opens instantly", "معاينة <bdi>3D</bdi> جاهزة · تفتح فورًا"),
      opening: t("Opening the studio…", "جارٍ فتح الاستوديو…"),
      // W7: read when the first view is built (the clock may arrive after this point; klik:eta-ready repaints it too)
      get lead() { return mtoHead(); },
    };
    // p4-cta-2: rooms say what this total gets (the room page's own rule, .kl-pdp-delivery[data-rule=threshold]): free at or
    // above the threshold, "from ⃁6,000" only below it; the amount in the riyal markup in both languages
    // wave1 pdp DL-5: the buy box's own fee sentence (feeText), never "free from ⃁6,000" on a set that qualifies
    const fee = () => esc(feeText());
    let dlg = null, sheet = null, wrap = null, custBtn = null, custTitle = null, custSub = null, title = null, img = null, opener = null, offer = null, pay = null, terms = null;
    let pushed = false, leaving = null, going = false, bypass = false, openedAt = 0, poll = 0, others = new Set(), mo = null;
    // open = data-kpdp-fv-open (a name no other rule uses). Toggling [hidden] cost 90-190 ms at CPU x4 on these pages (the
    // theme's [hidden] rules make it invalidate far beyond the element); this attribute costs one visibility change
    const shown = () => !!dlg && dlg.hasAttribute("data-kpdp-fv-open");
    const studioUp = () => {
      return studioOn() || [...document.querySelectorAll("dialog[open]")].some((d) => !others.has(d));
    };
    // a studio (or its opening screen) is on screen: it keeps its own history entries, so the first view never steps
    // history back under it (a stale first-view entry is stepped over later, see popstate)
    const studioOn = () => {
      const c = document.documentElement.className + " " + document.body.className;
      // (not .kz-on alone: the sofa-set root can keep that class after a studio closed through the system Back)
      return (
        /(^|\s)(hz-studio-active|kr-studio-open|kf-studio-open|sofa-fixed-open|ready-stock-open|klik-dpo-builder-active)(\s|$)/.test(c) ||
        !!document.querySelector("dialog.kd-opening[open], dialog.kr-workspace[open]")
      );
    };
    const pictureSrc = () => {
      const pick =
        document.querySelector(".kpd-gallery .product-main-slide:not(.is-clone) img, .product__main-photos .product-main-slide:not(.is-clone) img") ||
        document.querySelector(".klik-featured-image, .product-image-main img, .kl-gallery__main img, [data-kpd-page] .product__photos img");
      return pick ? { src: pick.currentSrc || pick.src || pick.dataset.src || "", srcset: pick.getAttribute("srcset") || pick.dataset.srcset || "" } : null;
    };
    const setPicture = () => {
      const pic = pictureSrc();
      if (pic?.src && img.getAttribute("src") !== pic.src) {
        if (pic.srcset) (img.setAttribute("srcset", pic.srcset), img.setAttribute("sizes", "(min-width: 990px) 560px, 100vw"));
        img.src = pic.src;
      }
      if (img.hidden !== !pic?.src) img.hidden = !pic?.src;
    };
    const focusables = () => [...dlg.querySelectorAll("button, a[href], input, select, textarea, [tabindex]:not([tabindex='-1'])")].filter((n) => !n.disabled && !n.hidden && n.getClientRects().length);
    // keyboard: Escape closes, Tab stays inside (the page behind is covered, so only the keyboard can leave)
    const onKey = (e) => {
      if (!shown()) return;
      if (e.key === "Escape") return void (e.preventDefault(), close("escape"));
      if (going || e.key !== "Tab") return;
      const list = focusables();
      if (!list.length) return;
      const first = list[0], last = list[list.length - 1], a = document.activeElement;
      if (e.shiftKey ? a === first || a === title || !dlg.contains(a) : a === last || !dlg.contains(a)) (e.preventDefault(), (e.shiftKey ? last : first).focus());
    };
    // focus that lands on the page behind (screen-reader virtual cursor, a script) comes back to the first view
    const onFocus = (e) => {
      if (!shown() || going || studioUp() || dlg.contains(e.target)) return;
      if (e.target?.closest?.("#MainContent, main, header, footer, aside.kpdp-bar")) try { title.focus({ preventScroll: true }); } catch (err) {}
    };
    const build = () => {
      if (dlg) return;
      dlg = make("div", "kpdp-fv");
      dlg.dir = ar ? "rtl" : "ltr";
      dlg.setAttribute("role", "dialog");
      dlg.setAttribute("aria-labelledby", "kpdp-fv-title");
      dlg.setAttribute("data-wg-notranslate", "");
      // the name the shopper reads on the page (the first visible h1; the store title can differ, e.g. «تى فى»)
      const h1 = [...document.querySelectorAll("main h1, h1")].find((h) => h.getClientRects().length) || document.querySelector(".kl-pdp-heading h1, .product-single__title");
      const name = h1?.textContent.replace(/\s+/g, " ").trim() || "";
      dlg.innerHTML =
        `<div class="kpdp-fv__sheet">` +
        `<header class="kpdp-fv__head"><button type="button" class="kpdp-fv__close" aria-label="${t("Close", "إغلاق")}">${X}</button>` +
        `<div class="kpdp-fv__names"><strong class="kpdp-fv__name">${bidi(name)}</strong><small class="kpdp-fv__kind">${copy.kind}</small></div><span class="kpdp-fv__end" aria-hidden="true"></span></header>` +
        `<div class="kpdp-fv__stage"><img class="kpdp-fv__img" alt="" decoding="async"></div>` +
        `<div class="kpdp-fv__body"><h2 class="kpdp-fv__title" id="kpdp-fv-title" tabindex="-1"></h2>` +
        `<div class="kpdp-cta kpdp-cta--fv" data-kind="fv"><button type="button" class="kpdp-cta-3d kpdp-fv__customise"><span class="kpdp-cta-3d__icon" aria-hidden="true">${ICON.cube}</span><span class="kpdp-cta-3d__text"><strong class="kpdp-cta-3d__title"></strong><small class="kpdp-cta-3d__sub">${copy.sub}</small></span><span class="kpdp-cta-3d__go" aria-hidden="true">${GO}</span></button></div>` +
        `<p class="kpdp-fv__offer" hidden></p><div class="kpdp-fv__pay" hidden></div>` +
        `<p class="kpdp-fv__meta"><span class="kpdp-fv__lead"${ready() ? "" : ' data-klik-eta="15" data-klik-eta-form="long"'}>${copy.lead}</span><span class="kpdp-fv__terms"></span></p></div></div>`;
      sheet = dlg.querySelector(".kpdp-fv__sheet");
      wrap = dlg.querySelector(".kpdp-cta--fv");
      custBtn = dlg.querySelector(".kpdp-fv__customise");
      custTitle = custBtn.querySelector(".kpdp-cta-3d__title");
      custSub = custBtn.querySelector(".kpdp-cta-3d__sub");
      title = dlg.querySelector(".kpdp-fv__title");
      img = dlg.querySelector(".kpdp-fv__img");
      offer = dlg.querySelector(".kpdp-fv__offer");
      pay = dlg.querySelector(".kpdp-fv__pay");
      terms = dlg.querySelector(".kpdp-fv__terms");
      // the as-pictured line and "Buy as pictured" move in here (their bindings and the adapter add go with them)
      if (line) wrap.append(line);
      wrap.append(add);
      document.body.append(dlg);
      try { document.dispatchEvent(new CustomEvent("klik:first-view-built", { detail: { node: dlg, productId: productId(), family: familyOf(), state: cta.dataset.state || "default" } })); } catch (e) {}
      setPicture();
      paint();
      paintProof();
      try { img.decode?.().catch(() => {}); } catch (e) {}
      // (Close, the backdrop, Customise and Buy are handled by the window listener below)
      document.addEventListener("keydown", onKey, true);
      document.addEventListener("focusin", onFocus, true);
      cta.__kpdpFvPaint = paint;
    };
    // p4-cta-2: what the buy box sells with, from the page's own nodes (no new data): the struck price and the offer, the
    // instalments line with the official Tabby/Tamara marks, the lead time and the delivery terms
    let proofSig = "";
    const paintProof = () => {
      const total = scope.querySelector(".kp6-total, .kl-pdp-price [data-total]");
      const old = total?.querySelector(".kprice__old");
      const src = scope.querySelector(".kprice-pay") || document.querySelector(".kp6-purchase .kprice-pay, .kl-pdp-panel .kprice-pay");
      const sig = (total?.dataset.kpriceSignature || "") + "|" + (old?.textContent || "") + "|" + (src?.textContent || "") + "|" + fee();
      if (sig === proofSig) return;
      proofSig = sig;
      let pct = 0, code = "";
      try { const s = JSON.parse(total?.dataset.kpriceSignature || "[]")[0] || {}; pct = Number(s.percent) || 0; code = s.campaign ? String(s.code || "") : ""; } catch (e) {}
      if (old && pct > 0) {
        const pill = code ? t(`${esc(code)} · ${pct}% off`, `خصم ${pct}٪ · <bdi>${esc(code)}</bdi>`) : t(`${pct}% off`, `خصم ${pct}٪`);
        offer.innerHTML = `<s class="kpdp-fv__was">${old.innerHTML}</s><span class="kpdp-fv__pill">${pill}</span>`;
        offer.hidden = false;
      } else offer.hidden = true;
      if (src) {
        const node = src.cloneNode(true);
        node.removeAttribute("data-klik-bnpl");
        node.removeAttribute("data-kpdp-pay");
        node.querySelectorAll("a, [id]").forEach((n) => (n.tagName === "A" ? n.remove() : n.removeAttribute("id")));
        node.className = "kprice-pay kpdp-fv__paysrc";
        pay.replaceChildren(node);
        pay.hidden = false;
      } else pay.hidden = true;
      terms.innerHTML = `${t("VAT included", "شامل الضريبة")}<span class="kpdp-sep"> · </span>${fee()}`;
    };
    const paint = () => {
      if (!dlg) return;
      const changed = cta.dataset.state === "changed";
      const tt = changed ? copy.yours : copy.ask;
      if (title.textContent !== tt) title.textContent = tt;
      // (p5-cfg-entry A6: a saved design on this device names the card "Continue your saved design", klik-pdp-plus)
      const ct = changed ? copy.edit : custBtn.dataset.resume === "saved" ? t("Continue your saved design", "أكمل تصميمك المحفوظ") : copy.custom;
      if (!going && custTitle.textContent !== ct) custTitle.textContent = ct;
      const st = changed ? "changed" : "default";
      if (dlg.dataset.state !== st) dlg.dataset.state = st;
      paintProof();
      try { cta.__kpdpRepaint?.(); } catch (e) {}
    };
    const paintReady = () => {
      if (!custSub || custBtn.dataset.resume === "saved") return;
      const hosts = [...document.querySelectorAll("[data-hazel-3d], [data-furniture-3d]")];
      const ok = hosts.some((h) => h.dataset.geometry === "ready" && h.klikViewer?.model);
      const html = ok ? copy.subReady : copy.sub;
      if (custSub.innerHTML !== html) custSub.innerHTML = html;
      custBtn.dataset.ready = ok ? "1" : "";
    };
    const lock = (on) => document.documentElement.classList.toggle("kpdp-fv-open", on);
    const finishClose = (focusBack) => {
      clearInterval(poll);
      mo?.disconnect();
      mo = null;
      if (shown()) (dlg.removeAttribute("data-kpdp-fv-open"), dlg.removeAttribute("aria-modal"));
      lock(false);
      going = false;
      if (custBtn) (custBtn.removeAttribute("aria-busy"), (custBtn.dataset.state = ""), paint());
      if (focusBack && opener?.isConnected) try { opener.focus({ preventScroll: true }); } catch (e) {}
    };
    // one history entry while the first view is open: the phone's Back closes it instead of leaving the page
    const leaveHistory = () =>
      new Promise((done) => {
        if (!pushed || history.state?.kpdpFv !== 1) return void ((pushed = false), done());
        leaving = done;
        history.back();
        setTimeout(() => leaving === done && ((leaving = null), (pushed = false), done()), 700);
      });
    addEventListener("popstate", (e) => {
      if (leaving) {
        const done = leaving;
        leaving = null;
        pushed = false;
        return void done();
      }
      if (pushed && shown()) return void ((pushed = false), closed("back"), finishClose(true));
      // a stale entry (a studio or the sheet opened over the first view): step over it instead of a dead Back press
      if (e.state?.kpdpFv === 1 && !shown()) (pushed = false), history.back();
    });
    // p5-cfg-entry A16: klik_pdp_first_view_closed {reason, ms_open} (x | back | escape | backdrop)
    const closed = (reason) => {
      const ms = openedAt ? Date.now() - openedAt : 0;
      publish("klik_pdp_first_view_closed", { reason, ms_open: ms });
      try { document.dispatchEvent(new CustomEvent("klik:first-view-closed", { detail: { reason, ms_open: ms } })); } catch (e) {}
    };
    const close = (reason) => {
      if (!shown()) return;
      if (reason) closed(reason);
      // while "Customise" is opening the studio the entry is already given back: close at once, and cancel the studio's
      // opening too (its own Close), so the shopper is back on the page
      if (going) {
        try { document.querySelector("dialog.kd-opening[open] .kd-opening__close")?.click(); } catch (e) {}
        return void finishClose(true);
      }
      leaveHistory().then(() => finishClose(true));
    };
    // a studio, the sheet or another dialog came up over the first view (the add opened the studio review, the
    // confirmation sheet, a kept tap): the first view steps aside
    const watch = () => {
      mo?.disconnect();
      const check = () => {
        if (!shown() || going || !studioUp()) return;
        if (!studioOn() && history.state?.kpdpFv === 1) return void leaveHistory().then(() => finishClose(false));
        pushed = false;
        finishClose(false);
      };
      mo = new MutationObserver(() => requestAnimationFrame(check));
      mo.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
      mo.observe(document.body, { attributes: true, attributeFilter: ["class"] });
      mo.observe(document.body, { attributes: true, subtree: true, attributeFilter: ["open"] });
    };
    const open = (from) => {
      build();
      opener = from || main;
      others = new Set(document.querySelectorAll("dialog[open]"));
      setPicture();
      paint();
      paintProof();
      // shown in the tap's own task: the overlay is already styled and laid out (closed it is only visibility:hidden), so
      // the tap changes one inherited property: no top layer, no inert page, no rule matching for its subtree
      dlg.setAttribute("data-kpdp-fv-open", "");
      try { performance.mark?.("kpdp:fv-open"); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent("klik:first-view-open", { detail: { node: dlg, state: cta.dataset.state || "default" } })); } catch (e) {}
      openedAt = Date.now();
      // the first view paints first; everything else waits for the next task (instant even on a busy phone): every
      // class or focus change costs a whole-page style pass on this theme (≈0.3 s on a mid phone)
      requestAnimationFrame(() =>
        setTimeout(() => {
          if (!shown()) return;
          // aria-modal one task after the paint: the product dock watches it on every [role=dialog] and hides the WhatsApp
          // float with [hidden] (a ~280-node restyle at CPU x4) — under the overlay, so a frame later is never seen
          dlg.setAttribute("aria-modal", "true");
          lock(true);
          try { history.pushState(Object.assign({}, history.state || {}, { kpdpFv: 1 }), ""); pushed = true; } catch (e) { pushed = false; }
          try { if (!dlg.contains(document.activeElement)) title.focus({ preventScroll: true }); } catch (e) {}
          paintReady();
          clearInterval(poll);
          poll = setInterval(paintReady, 600);
          watch();
          publish("klik_pdp_design_3d_selected");
          // A2: the reading time warms the studio (heavy steps in whenQuiet, after this paint)
          studioIntent("first-view");
          // both ways need the family's data: the adapter warms now (options form, pictured design); the 3D warm-up
          // started with the finger on the button (warmStudio)
          try { window.KlikOrderAsShown?.get?.()?.warm?.(); } catch (e) {}
        }, 0),
      );
    };
    // "Customise size & fabric": the studio opens through its own handler (the same as before the first view), and the
    // first view stays on screen until the studio (or its opening screen) is up, so the page never flashes between
    const customise = (resume) => {
      if (going) return;
      going = true;
      try {
        const root = document.querySelector("[data-klik-dpo-wizard], [data-design-flow]");
        const r = resume || custBtn?.dataset.resume || "";
        if (root) r ? (root.dataset.kwResume = r) : delete root.dataset.kwResume;
      } catch (e) {}
      // (klik_pdp_customize_selected: published in fire() below, or by the primary's own click listener on the fallback)
      custBtn.dataset.state = "loading";
      custBtn.setAttribute("aria-busy", "true");
      custTitle.textContent = copy.opening;
      mo?.disconnect();
      leaveHistory().then(() => {
        const t0 = Date.now();
        let clicks = 0;
        // the studio's own open (klik-product-flow.js exposes it on the primary): no second click event, so no document
        // click listener (the Meta pixel's ≈2 s) runs before the studio starts; a click is the fallback
        const fire = () => {
          clicks++;
          if (typeof main.__kpdpOpen === "function") {
            if (clicks === 1) publish("klik_pdp_customize_selected");
            try { main.__kpdpOpen(); } catch (e) {}
            return;
          }
          bypass = true;
          main.click();
          bypass = false;
        };
        // one loading state: the first view (its photo and "Opening the studio…") stays on top until the studio is
        // revealed and usable (a warm studio: its opening screen never shows in between); when it needs longer than
        // 1.5 s its own opening screen takes over (progress, "Continue choosing my details", Close). The reveal
        // (data-studio-revealed) is caught by an observer in the same task, so the studio's reveal animation shows.
        const was = new Set(document.querySelectorAll("[data-studio-revealed='true']"));
        let cmo = null;
        const done = () => {
          cmo?.disconnect();
          cmo = null;
          finishClose(false);
          try { document.activeElement?.blur?.(); } catch (e) {}
          try { document.querySelector('.kz-on [tabindex="-1"], .hz-studio [tabindex="-1"], dialog.kr-workspace [tabindex="-1"]')?.focus({ preventScroll: true }); } catch (e) {}
        };
        const ready = () => {
          if (!studioUp()) return false;
          if (!document.querySelector("dialog.kd-opening[open]") || Date.now() - t0 > 1500) return true;
          return [...document.querySelectorAll("[data-studio-revealed='true']")].some((n) => !was.has(n));
        };
        cmo = new MutationObserver(() => going && ready() && done());
        cmo.observe(document.body, { attributes: true, subtree: true, attributeFilter: ["data-studio-revealed", "open"] });
        cmo.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
        fire();
        const tick = () => {
          if (!going) return void (cmo?.disconnect(), (cmo = null));
          const ms = Date.now() - t0;
          if (ready()) return void done();
          // the studio was not ready to open yet (its controller still mounting): ask again
          if (!studioUp() && ms > 2500 * clicks && clicks < 6) fire();
          if (ms > 20000) return void (cmo?.disconnect(), (cmo = null), finishClose(true));
          setTimeout(tick, 100);
        };
        setTimeout(tick, 60);
      });
    };
    /* The taps are taken on window, in the capture phase, before any document listener. Measured on staging (phone,
       CPU x4): the Meta pixel's "automatic events" click listener (connect.facebook.net signals/config, a document
       capture listener) ran 8.2 s before our handler, so the first view painted 11-12 s after the tap. These taps end
       here (the pixel does not see them; Shopify analytics gets our own events), so the first view, Close and Customise
       answer at once. "Buy as pictured" goes straight to the family adapter when it is registered and nothing else needs
       the tap (the kz design with tables keeps its review path; before the page has loaded the kept-tap script decides). */
    const kzTables = () => {
      const w = document.querySelector("[data-klik-dpo-wizard]");
      try { return w?.dataset.klikOrderAsShown === "kz" && JSON.parse(w.dataset.klikTables || "[]").length > 0; } catch (e) { return true; }
    };
    const stop = (e) => (e.preventDefault(), e.stopImmediatePropagation());
    addEventListener(
      "click",
      (e) => {
        if (bypass || !e.target?.closest) return;
        const tg = e.target;
        const b = tg.closest(".kpdp-cta-3d--primary, .kpdp-bar-buy--3d");
        if (b && (b === main || b.classList.contains("kpdp-bar-buy--3d"))) {
          if (main.dataset.kpdpShared === "1") return void stop(e);
          // p4-cta-2 (§1.13b): a furniture chip choice made in the buy box is added directly by the one button (checked
          // before the no-first-view switch, so the chip path keeps working)
          if (cta.dataset.kpdpDirect === "1" && document.readyState === "complete" && window.KlikOrderAsShown?.get?.()) {
            stop(e);
            publish("klik_pdp_buy_as_pictured", { state: "changed", source: "chips" });
            window.KlikOrderAsShown.tryAdd(box, main, { label: main.querySelector(".kpdp-cta-3d__title") });
            return;
          }
          if (skip()) return;
          stop(e);
          if (!shown()) open(b);
          return;
        }
        if (!shown() || !dlg.contains(tg)) return;
        if (tg === dlg || tg.closest(".kpdp-fv__close")) return void (stop(e), close(tg === dlg ? "backdrop" : "x"));
        if (tg.closest(".kpdp-fv__customise")) return void (stop(e), customise());
        if (tg.closest(".kpdp-cta-add") === add) {
          publish("klik_pdp_buy_as_pictured", { state: cta.dataset.state || "default" });
          if (document.readyState !== "complete" || !window.KlikOrderAsShown?.get?.() || kzTables()) return;
          stop(e);
          window.KlikOrderAsShown.tryAdd(box, add);
        }
      },
      true,
    );
    // p4-cta-2: a tap does not move focus onto the one button. Measured at CPU x4: the focus change wakes two layout-reading
    // rAF scripts (product dock, purchase guide: focusin) and restyles ~280 nodes in the very frame the first view paints
    // (presentation 0.5-0.8 s, the same as tapping a do-nothing button). Focus goes into the first view one task after it
    // painted (its title), and back to the button when it closes; keyboard activation is unchanged.
    addEventListener(
      "mousedown",
      (e) => {
        const b = e.target?.closest?.(".kpdp-cta-3d--primary, .kpdp-bar-buy--3d");
        if (b && (b === main || b.classList.contains("kpdp-bar-buy--3d")) && !skip() && cta.dataset.kpdpDirect !== "1") e.preventDefault();
      },
      true,
    );
    // the sheet (KlikOrderAsShown.tryAdd → KlikCartAdded) opens after the first view has closed and given back its entry
    window.__kpdpFvBeforeSheet = () => (shown() ? leaveHistory().then(() => finishClose(false)) : null);
    // p5-cfg-entry: the contract for klik-pdp-plus.js and QA (node, state, the resume Customise, extras, a repaint)
    window.KlikStudioFirstView = Object.freeze({
      open: (from) => !skip() && (open(from || main), true),
      close: () => close("x"),
      isOpen: shown,
      node: () => (build(), dlg),
      state: () => cta.dataset.state || "default",
      customise: (resume) => {
        // no first view (fvNone): straight into the studio through the one button (the resume intent goes on the studio root)
        if (!shown() && skip()) {
          try { const root = document.querySelector("[data-klik-dpo-wizard], [data-design-flow]"); if (root) resume ? (root.dataset.kwResume = resume) : delete root.dataset.kwResume; } catch (e) {}
          main.click();
          return;
        }
        return shown() ? customise(resume) : (open(main), setTimeout(() => customise(resume), 0));
      },
      extra: (key, value) => cta.__kpdpExtra?.(key, value),
      cfg: () => cta.__kpdpCfg?.() || null,
      refresh: () => (paint(), cta.__kpdpRepaint?.()),
      main: () => main,
    });
    // p4-cta-2: a tap on the one button before this point was kept by klik-pdp-actions (it showed "Opening…"); it opens now
    try { document.dispatchEvent(new CustomEvent("klik:first-view-ready")); } catch (e) {}
    // built ahead in idle time after load (the photo decoded too), so the tap only removes [hidden]
    const prebuild = () => (typeof requestIdleCallback === "function" ? requestIdleCallback(() => !skip() && build(), { timeout: 3000 }) : setTimeout(() => !skip() && build(), 400));
    document.readyState === "complete" ? prebuild() : addEventListener("load", prebuild, { once: true });
  }
  function enhance(box) {
    if (box.dataset.kpdp) return;
    box.dataset.kpdp = "1";
    const scope = box.closest(".kp6-purchase, .kl-pdp-panel") || box.parentElement;
    try { modeSwitch(scope); } catch (e) {}
    try { makeItYours(box, scope); } catch (e) {}
    try { firstView(box, scope); } catch (e) {}
    const price = scope.querySelector(".kp6-price-note") || scope.querySelector(".kp6-total") || scope.querySelector(".kl-pdp-price");
    if (price && !scope.querySelector(".kpdp-pay, [data-kpdp-pay], [data-klik-bnpl]")) price.after(payLine());
    const actions = box.querySelector(".kflow-actions");
    const delivery = deliveryBlock();
    (actions || box).after(delivery);
    try { liveFee(delivery); } catch (e) {}
    const trust = trustList();
    delivery.after(trust);
    // wave1 pdp G-02: a visitor whose device is set to a Gulf time zone sees the delivery-scope note right under the
    // delivery promise (klik-gulf-note: no request, no tracking, dismissible)
    try {
      const gulf = window.KlikGulfNote?.clone?.("pdp");
      if (gulf) delivery.after(gulf);
    } catch (e) {}
    // release 5+ (pdp-verify V-06): proof near the decision — the lead real Google review (klik-customer-stories part
    // 'snippet', server template in klik-pdp-before) under the trust list. Desktop only (klik-v3-final-pdp.css hides it
    // below 990px, where the first screen has no room and the studio's first view shows the same review).
    try {
      const tpl = document.querySelector("template[data-kcs-proof-template]")?.content;
      const proof = tpl?.querySelector(".kcs-proof");
      if (proof && !scope.querySelector(".kpdp-proof")) {
        const node = proof.cloneNode(true);
        node.classList.add("kpdp-proof");
        const css = tpl.querySelector("style");
        if (css) node.prepend(css.cloneNode(true));
        trust.after(node);
      }
    } catch (e) {}
    box.append(helpLine(scope));
    // §1.13: the studio opens from ONE quiet text link with the cube icon
    const build = box.querySelector(".kflow-primary");
    if (build && !build.querySelector(".kpdp-ico, .kpdp-cta-3d__icon")) build.insertAdjacentHTML("afterbegin", `<span class="kpdp-ico" aria-hidden="true">${ICON.cube}</span>`);
    if (build && !build.dataset.kpdpIntent)
      (build.dataset.kpdpIntent = "1"), build.addEventListener("click", () => publish("klik_pdp_customize_selected"), { passive: true });
    document.documentElement.classList.add("kpdp-on");
    stickyBar(box);
  }

  /* ---------- sticky buy bar (§1.13a, 2026-10-22: the total · Add to cart (primary) · a compact 3D button (cube + "3D")
     for studio families, exactly like before; ready to ship: the total and Add to cart only).
     It shows only while the buy box's own buttons are out of view (K-053, §3.13), never while a studio is open, and
     never over the footer (its legal links stay reachable, D-22). ---------- */
  function stickyBar(box) {
    if (document.querySelector(".kpdp-bar")) return;
    // p4-cta: on studio families the Add lives in the studio's first view (hidden holder, then the dialog): the bar's one
    // button is the primary "Design it in 3D" (cube icon), which opens that first view
    /* wave1 pdp SP-02 (2026-10-27): asShown() reads layout (getClientRects); its answer is kept until something that can
       change it happens (a mutation in the buy box's actions, a root class or dialog change, a resize, a tap or a key:
       invalidate() below), so a render never forces a layout of its own. */
    let asCache;
    const asShown = () => {
      if (asCache !== undefined) return asCache;
      const a = box.querySelector(".kflow-as-shown");
      // a button the page does not display (ready to ship: no Add to cart outside the configurator) is not the bar's target
      return (asCache = a && !a.closest("[hidden], dialog, .kpdp-fv") && a.getClientRects().length > 0 ? a : null);
    };
    const customise = () => box.querySelector(".kflow-primary");
    // owner 2026-10-23: ready to ship opens the configurator too (no Add to cart outside it) — the bar is the 3D button
    const oneButton = !!box.querySelector(".kpdp-cta--studio .kpdp-cta-3d--primary, .kpdp-cta--ready .kpdp-cta-3d--ready");
    const bar = make("aside", "kpdp-bar");
    bar.hidden = true;
    bar.dir = ar ? "rtl" : "ltr";
    bar.setAttribute("aria-label", t("Order this product", "اطلب هذا المنتج"));
    bar.innerHTML =
      `<div class="kpdp-bar-info"><strong></strong><span class="kpdp-bar-price"></span></div>` +
      `<button type="button" class="kpdp-bar__3d" hidden aria-label="${t("Design it in 3D", "صمّم طلبك بتقنية 3D")}"><span class="kpdp-bar__3d-icon" aria-hidden="true">${ICON.cube}</span><span>3D</span></button>` +
      `<button type="button" class="kpdp-bar-buy${oneButton ? " kpdp-bar-buy--3d" : ""}"${oneButton ? ' aria-haspopup="dialog"' : ""}><span class="kpdp-bar-buy__icon" aria-hidden="true">${oneButton ? ICON.cube : CART}</span>${oneButton ? '<span class="kpdp-bar-buy__text"><span class="kpdp-bar-buy__label"></span><small class="kpdp-bar-buy__sub"></small></span>' : '<span class="kpdp-bar-buy__label"></span>'}</button>` +
      `<p class="kpdp-bar__error" role="alert" hidden></p>`;
    document.body.append(bar);
    bar.querySelector("strong").textContent = document.querySelector("h1")?.textContent.trim() || "";
    bar.querySelector(".kpdp-bar-buy").addEventListener("click", () => {
      asCache = undefined;
      const as = asShown();
      (as && !as.hidden ? as : customise())?.click();
    });
    bar.querySelector(".kpdp-bar__3d").addEventListener("click", () => customise()?.click());
    const priceNode = () => document.querySelector(".kp6-total .kprice__current, .kl-pdp-price .kprice__current");
    let actionsVisible = true;
    let footerVisible = false;
    let priceDirty = true;
    // wave1 pdp P0-3 PDP-1 / P0-6 #5: the bar's second line names the two choices in short form ("Starts as pictured"
    // described the tool; «يبدأ كما في الصورة» read translated). Kept to the length that leaves the bar at its 74 px on a
    // 390 px phone (measured: the longer "…your size & fabric" wrapped the product name to a second line)
    const barSub = () => {
      if (box.querySelector(".kpdp-cta")?.dataset.kind === "ready" || ready()) return t("Size and colour", "المقاس واللون");
      // wave1-fix pdp-04: "your pieces" only on bedroom and dining SETS; a single room piece (bedside table, vanity, chair)
      // has no pieces to choose
      if (kind() === "bedroom" || kind() === "dining") return t("As pictured, or your pieces", "كما في الصورة، أو بقطعك");
      return t("As pictured, or your size", "كما في الصورة، أو بمقاسك");
    };
    const studioOpen = () =>
      document.documentElement.classList.contains("hz-studio-active") ||
      document.body.classList.contains("kr-studio-open") ||
      !!document.querySelector(".kz-on, dialog[open], [aria-modal='true']:not([hidden])");
    const render = () => {
      const as = asShown();
      const buy = as && !as.hidden ? as : customise();
      // the bar button reads "Add to cart" (the as-pictured detail stays in the box) and mirrors the Add states
      const st = buy?.dataset.state || "idle";
      const label = st === "error" ? t("Try again", "حاول مجددًا") : buy?.classList.contains("kpdp-cta-add") ? (buy.querySelector(".kpdp-cta-add__label")?.textContent || "").trim() || t("Add to cart", "أضف إلى السلة") : ((buy?.querySelector(".kpdp-cta-3d__title, .kpdp-cta-add__label") || buy)?.textContent || "").trim();
      const button = bar.querySelector(".kpdp-bar-buy");
      const buyLabel = button.querySelector(".kpdp-bar-buy__label") || button;
      if (buyLabel.textContent !== label) buyLabel.textContent = label;
      // p5-cfg-entry A8 (KD-10): "Design it in 3D" over "Buy as pictured or customise" (one navy button, two lines)
      const sub = button.querySelector(".kpdp-bar-buy__sub");
      if (sub) {
        const m = customise();
        const plain3d = oneButton && st !== "error" && box.querySelector(".kpdp-cta")?.dataset.kpdpDirect !== "1" && m?.dataset.kpdpShared !== "1" && box.querySelector(".kpdp-cta")?.dataset.state !== "changed" && !/^(Continue|أكمل)/.test(label);
        const subText = plain3d ? barSub() : "";
        if (sub.textContent !== subText) sub.textContent = subText;
        if (sub.hidden !== !subText) sub.hidden = !subText;
        const shared = m?.dataset.kpdpShared === "1";
        if (shared !== !!button.__kpdpShared) ((button.__kpdpShared = shared), shared ? button.setAttribute("aria-busy", "true") : button.removeAttribute("aria-busy"));
      }
      // refine: the no-adapter path's spinner stops as soon as the studio is on screen (never stuck behind it)
      if (studioOpen()) for (const b of box.querySelectorAll('.kpdp-cta-add[data-state="loading"]:not([aria-busy])')) b.dataset.state = "idle";
      if (button.dataset.state !== st) button.dataset.state = st;
      const three = bar.querySelector(".kpdp-bar__3d");
      const showThree = !!customise() && buy !== customise() && !customise().hidden && box.querySelector(".kpdp-cta")?.dataset.kind !== "ready";
      if (three.hidden === showThree) three.hidden = !showThree;
      bar.classList.toggle("kpdp-bar--3d", showThree);
      // p4-cta-2 (§1.13b): a furniture chip choice is added directly by the one button: the cart icon, no popup
      if (oneButton) {
        const direct = box.querySelector(".kpdp-cta")?.dataset.kpdpDirect === "1";
        const ic = button.querySelector(".kpdp-bar-buy__icon");
        if (ic && (ic.dataset.icon || "cube") !== (direct ? "cart" : "cube")) ((ic.innerHTML = direct ? CART : ICON.cube), (ic.dataset.icon = direct ? "cart" : "cube"));
        if (direct === button.hasAttribute("aria-haspopup")) direct ? button.removeAttribute("aria-haspopup") : button.setAttribute("aria-haspopup", "dialog");
      }
      // (wave1 pdp SP-02: the price is copied when the buy-box total changed, not compared on every render)
      if (priceDirty) {
        const p = priceNode();
        const target = bar.querySelector(".kpdp-bar-price");
        if (p) priceDirty = false;
        if (p && target.innerHTML !== p.innerHTML) target.innerHTML = p.innerHTML;
      }
      // (desktop: read live on every scroll frame; a jump from below the fold to above it never crosses the observer)
      if (wide.matches && actions) actionsVisible = actions.getBoundingClientRect().bottom > 0;
      const show = !actionsVisible && !footerVisible && !!buy && !studioOpen();
      if (show && (bar.hidden || alignDue)) align();
      if (bar.hidden === show) bar.hidden = !show;
      document.body.classList.toggle("kpdp-bar-on", show);
      const err = bar.querySelector(".kpdp-bar__error");
      const showErr = show && st === "error";
      if (err && err.hidden === showErr) ((err.hidden = !showErr), (err.textContent = showErr ? ADD_ERROR() : ""));
    };
    let queued = false;
    const schedule = () => queued || ((queued = true), requestAnimationFrame(() => ((queued = false), render())));
    const invalidate = () => ((asCache = undefined), schedule());
    const actions = box.querySelector(".kflow-actions");
    /* p4-cta-2 (owner rule NO OVERLAPS): from 990px the bar is never drawn over the buy box. It shows only once the in-page
       actions have scrolled ABOVE the viewport (on a laptop the one-button block sits right at the fold, and the CSS
       from-load rule put the bar over it; klik-v3-final-pdp.css switches that rule off from 990px), and it lines up with
       the buy column. Phone keeps the from-load bar (DESIGN-V3 §4.1): actions below the viewport count as out of view. */
    const wide = matchMedia("(min-width: 990px)");
    let alignDue = true;
    /* release 5 (pdp-verify V-02, owner rule NO OVERLAPS): a floating card at the bottom of the buy column covered the
       lower page (questions, rails, reviews, Size labels). From 990px the bar docks at the end of the sticky section nav
       (.kpe-navbar: Size · Reviews · Details · Questions), so it never sits over content; phone keeps the bottom bar. */
    const dock = document.querySelector(".kpe-navbar");
    const home = bar.parentNode;
    const align = () => {
      alignDue = false;
      const props = ["left", "right", "width", "max-width"];
      const docked = wide.matches && !!dock;
      if (docked !== bar.classList.contains("kpdp-bar--dock")) {
        (docked ? dock : home).append(bar);
        bar.classList.toggle("kpdp-bar--dock", docked);
      }
      if (!wide.matches || docked) return void props.forEach((p) => bar.style.removeProperty(p));
      const r = (actions || box).getBoundingClientRect();
      if (!r.width) return;
      bar.style.setProperty("left", Math.round(r.left) + "px", "important");
      bar.style.setProperty("right", "auto", "important");
      bar.style.setProperty("width", Math.round(r.width) + "px", "important");
      bar.style.setProperty("max-width", "none", "important");
    };
    window.addEventListener("resize", () => ((alignDue = true), invalidate()), { passive: true });
    if ("IntersectionObserver" in window) {
      if (actions)
        new IntersectionObserver((entries) => {
          actionsVisible = entries.some((e) => e.isIntersecting || (wide.matches && e.boundingClientRect.top > innerHeight));
          schedule();
        }).observe(actions);
      else actionsVisible = false;
      const footer = [...document.querySelectorAll("[id^='shopify-section'][id*='footer'], .site-footer, body > footer, #MainContent ~ footer")].pop();
      if (footer)
        new IntersectionObserver((entries) => {
          footerVisible = entries.some((e) => e.isIntersecting);
          schedule();
        }).observe(footer);
    } else actionsVisible = false;
    // K-047: no page-wide observer — the studios announce themselves through dialogs/classes; a narrow watch on the
    // root classes and the open attribute of dialogs (attribute changes only, no subtree text) is enough
    const mo = new MutationObserver(invalidate);
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    mo.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    mo.observe(document.body, { attributes: true, subtree: true, attributeFilter: ["open", "aria-modal"] });
    if (actions) new MutationObserver(invalidate).observe(actions, { attributes: true, subtree: true, childList: true, attributeFilter: ["hidden", "data-state"] });
    // cta2-fix2: the bar price follows the buy-box total (a furniture size chip re-renders it after the tap)
    const totalHost = priceNode()?.closest(".kp6-total, .kl-pdp-price");
    if (totalHost) new MutationObserver(() => ((priceDirty = true), schedule())).observe(totalHost, { childList: true, subtree: true, characterData: true });
    // the studio root's own class (.kz-on) changes after a tap or a key: re-check then
    for (const type of ["click", "keyup"]) document.addEventListener(type, () => setTimeout(invalidate, 60), { capture: true, passive: true });
    /* wave1 pdp SP-02: on phones the bar follows its two IntersectionObservers (the buy-box actions, the footer) and the
       studio / dialog observers above; a scroll listener ran render() on every frame (getClientRects, innerHTML compare).
       From 990px the bar docks to the section nav and reads the actions live, so a scroll still re-renders it there. */
    const onScroll = () => schedule();
    const scrollWatch = () => (wide.matches ? window.addEventListener("scroll", onScroll, { passive: true }) : window.removeEventListener("scroll", onScroll));
    scrollWatch();
    if (wide.addEventListener) wide.addEventListener("change", () => ((alignDue = true), scrollWatch(), invalidate()));
    render();
  }

  /* ---------- gallery: counter for the slideshow, swipe for the room gallery ---------- */
  function galleryCounter() {
    const slideshow = document.querySelector(".kpd-gallery .product__main-photos");
    if (slideshow && !slideshow.querySelector(".kpdp-count")) {
      const slides = () => [...slideshow.querySelectorAll(".product-main-slide")].filter((s) => !s.classList.contains("is-clone"));
      if (slides().length > 1) {
        const count = make("span", "kpdp-count");
        slideshow.append(count);
        const paint = () => {
          const all = slides();
          const i = Math.max(0, all.findIndex((s) => s.classList.contains("is-selected")));
          count.textContent = `${i + 1} / ${all.length}`;
        };
        new MutationObserver(paint).observe(slideshow, { attributes: true, subtree: true, attributeFilter: ["class"] });
        paint();
      }
    }
    const room = document.querySelector(".kl-gallery");
    const main = room?.querySelector(".kl-gallery__main");
    const thumbs = room ? [...room.querySelectorAll(".kl-thumbs [data-photo]")] : [];
    if (main && thumbs.length > 1 && !main.querySelector(".kpdp-count")) {
      const count = make("span", "kpdp-count");
      main.append(count);
      const current = () => Math.max(0, thumbs.findIndex((b) => b.getAttribute("aria-pressed") === "true"));
      const paint = () => (count.textContent = `${current() + 1} / ${thumbs.length}`);
      new MutationObserver(paint).observe(room.querySelector(".kl-thumbs"), { attributes: true, subtree: true, attributeFilter: ["aria-pressed"] });
      paint();
      let x0 = null, y0 = null;
      main.addEventListener("pointerdown", (e) => ((x0 = e.clientX), (y0 = e.clientY)), { passive: true });
      main.addEventListener("pointerup", (e) => {
        if (x0 === null) return;
        const dx = e.clientX - x0, dy = e.clientY - y0;
        x0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        const forward = ar ? dx > 0 : dx < 0;
        const next = (current() + (forward ? 1 : thumbs.length - 1)) % thumbs.length;
        thumbs[next].click();
      });
      main.style.touchAction = "pan-y";
    }
  }

  /* ---------- studio names: store titles carry the brand ("KLIK Sukun — Bedroom Set"), the page says "Sukun
     Bedroom Set". The studio header takes the page's own name; piece rows and summaries lose the "KLIK " prefix. ---------- */
  function studioNames() {
    const brand = /^(\s*)(?:KLIK|كليك)\s+(?!Decor\b|ديكور)(?=\S)/;
    const roots = "dialog.kr-workspace, .hz-studio, .kz-on, .kf-studio, [data-design-flow]";
    const heading = () =>
      (document.querySelector(".kl-pdp-heading h1, .product-single__title") || document.querySelector("main h1"))?.textContent.replace(/\s+/g, " ").trim() || "";
    const clean = () => {
      const name = heading();
      document.querySelectorAll(roots).forEach((root) => {
        root.querySelectorAll("[data-kr-product-name], .kf-product-name, .kd-top .kd-product").forEach((el) => {
          if (name && brand.test(el.textContent) && el.textContent.trim() !== name) el.textContent = name;
        });
        // the options app's form (thousands of fabric labels, never product names) is skipped as a whole
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
          acceptNode: (n) =>
            n.nodeType === 1
              ? n.id === "itoris_dynamicproductoptions" || /^(SCRIPT|STYLE|TEXTAREA|svg)$/.test(n.tagName)
                ? NodeFilter.FILTER_REJECT
                : NodeFilter.FILTER_SKIP
              : brand.test(n.nodeValue)
                ? NodeFilter.FILTER_ACCEPT
                : NodeFilter.FILTER_SKIP,
        });
        const hits = [];
        while (walker.nextNode()) hits.push(walker.currentNode);
        hits.forEach((n) => (n.nodeValue = n.nodeValue.replace(brand, "$1")));
      });
    };
    let queued = false;
    const schedule = () => queued || ((queued = true), setTimeout(() => ((queued = false), clean()), 250));
    // K-047 / PF-13: the page-wide text watch starts only once a studio can be open (first intent on the buy box, a
    // studio link in the address, or a studio root already on the page) instead of from the first paint
    let watching = false;
    const watch = () => {
      if (watching) return;
      watching = true;
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
      clean();
    };
    if (/[?&](studio=1|klik-edit=|klik_sofa_mode=)/.test(location.search) || /klik-(config|design)/.test(location.hash) || document.querySelector(roots)) watch();
    else
      for (const type of ["pointerdown", "focusin", "keydown"])
        document.addEventListener(type, (e) => e.target.closest?.("button, a, [role='button'], label, summary") && watch(), { capture: true, passive: true });
  }
  studioNames();

  /* ---------- owner 2026-10-22: "configurator should always start with default or as pictured … customers inside the
     configurator should have the option to reset to as pictured". The sofa-set (nav.kz-tabs), corner and furniture
     (nav.kd-steps) studios get "Reset to as pictured" under their steps: it clears this product's saved design (the keys
     the controllers write) and reopens the studio fresh (?studio=1), which starts as pictured. Rooms keep their own
     "Start again from the original selection". ---------- */
  function studioReset() {
    const pid = () =>
      document.querySelector("[data-klik-dpo-wizard]")?.dataset.productId ||
      document.querySelector("[data-kpdp-actions][data-product-id]")?.dataset.productId ||
      String(window.ShopifyAnalytics?.meta?.product?.id || "");
    const place = () => {
      if (!/(^|\s)(hz-studio-active|kf-studio-open|klik-dpo-builder-active)(\s|$)/.test(document.documentElement.className + " " + document.body.className)) return;
      /* fast-convert RUN (page budget, tap -> studio): when every place the check below could choose already holds its
         link (each .kz-scroll, and each nav.kd-steps' box), it would return whatever is visible, so it returns here
         before any layout read. Fix round B1: "a link anywhere" was not enough (on the sofa-set studio a link under the
         rail's hidden steps could keep the visible one from being added). */
      if ([...document.querySelectorAll(".kz-panel > .kz-scroll")].every((n) => n.querySelector(":scope > .klik-reset-pictured")) && [...document.querySelectorAll("nav.kd-steps")].every((n) => n.parentElement?.querySelector(":scope > .klik-reset-pictured"))) return;
      // the sofa-set studio repaints .kz-view on every change: the link goes first in its scroll box (.kz-scroll), outside it
      const kzScroll = [...document.querySelectorAll(".kz-panel > .kz-scroll")].find((n) => n.getBoundingClientRect().height > 0);
      const nav = kzScroll ? null : [...document.querySelectorAll("nav.kd-steps")].find((n) => n.getBoundingClientRect().height > 0);
      if (kzScroll ? kzScroll.querySelector(":scope > .klik-reset-pictured") : !nav || nav.parentElement.querySelector(":scope > .klik-reset-pictured")) return;
      const b = make("button", "klik-reset-pictured");
      b.type = "button";
      b.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 12a8 8 0 1 0 2.4-5.7"/><path d="M4 4v4h4"/></svg><span>${t("Reset to as pictured", "ارجع إلى التصميم كما في الصورة")}</span>`;
      b.addEventListener("click", () => {
        const id = pid();
        for (const k of [`klik-dpo-design-${id}`, `klik-preset-v1:${id}`, `klikConfigurationDraft:${id}`]) {
          try { localStorage.removeItem(k); } catch (e) {}
          try { sessionStorage.removeItem(k); } catch (e) {}
        }
        publish("klik_studio_reset_pictured");
        const u = new URL(location.href);
        u.hash = "";
        for (const k of ["klik-edit", "klik_set_editor", "klik_sofa_mode"]) u.searchParams.delete(k);
        u.searchParams.set("studio", "1");
        location.replace(u.toString());
      });
      kzScroll ? kzScroll.prepend(b) : nav.after(b);
    };
    // the frame after the studio's root class changes, as on live (fix round B1: an idle-time check let the panel paint
    // without the link and pushed it down ~48 px when the link came, 0.9-2.4 s later)
    const mo = new MutationObserver(() => requestAnimationFrame(place));
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    mo.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    place();
  }
  try { studioReset(); } catch (e) {}

  /* ---------- owner 2026-10-23 "make sure they are integrated with the new system and the flow makes sense": pillows and
     part fabrics are chosen in the Fabric step ("Pillows and parts", klik-fabric-flow.js). The Review only says what the set
     gets, inside "Your set", with one link back to that step, so there is a single place to change them. ---------- */
  function pillowSummary() {
    const clean = (v) => String(v || "").replace(/\s*·?\s*\b(?:AG|AN|KF)-[\w-]+/g, "").replace(/\s+\d{6,}\b/g, "").replace(/(\s*·\s*)+$/, "").trim();
    const root = () => document.querySelector("[data-klik-dpo-wizard].kz-on");
    const snapOf = (pc, name) => (Array.isArray(pc.customSnapshot) ? pc.customSnapshot.find((e) => e.name === name) : null)?.value;
    const pieceState = (pc, live) => {
      const r = root();
      let src = "original", mix = "{}";
      if (live && r) {
        src = r.querySelector('select[data-hz="pillow-fabric"]')?.value || "original";
        mix = r.querySelector('[data-hz="material-mix"]')?.value || "{}";
      } else {
        src = snapOf(pc, "properties[_Sofa pillow-fabric]") || "original";
        mix = snapOf(pc, "properties[_KLIK upholstery]") || "{}";
      }
      let m = {};
      try { m = JSON.parse(mix); } catch (e) {}
      const each = Object.keys(m.pillows || {}).length;
      const text = each ? t("Chosen one by one", "باختيار منفرد") : src === "same" ? t("Same as the sofa", "نفس قماش الكنبة") : src === "original" ? t("As pictured", "كما في الصورة") : clean(pc.previewState?.pillowFabric?.name) || t("Your choice", "اختيارك");
      return { text, zones: Object.keys(m.zones || {}).length, pillows: (Number(pc.previewState?.pillowCount) || 0) + (pc.previewState?.extraPillows || []).reduce((n, x) => n + (Number(x.count) || 0), 0) };
    };
    const summary = () => {
      const set = window.sofaSet;
      if (!set?.pieces?.length) return null;
      const states = set.pieces.map((pc) => pieceState(pc, pc.id === set.activeId));
      const withPillows = states.filter((x) => x.pillows > 0);
      const texts = [...new Set(withPillows.map((x) => x.text))];
      const pillow = !withPillows.length ? "" : texts.length === 1 ? texts[0] : t("Different on each piece", "مختلف لكل قطعة");
      const zonePieces = states.filter((x) => x.zones > 0).length;
      let parts = "";
      if (zonePieces) {
        const here = [...(root()?.querySelectorAll("[data-kup-property]") || [])].filter((n) => !/^properties\[(Pillow|المخدة) \d/.test(n.name)).map((n) => n.name.replace(/^properties\[|\s*fabric\]$/g, "") + ": " + clean(n.value));
        parts = zonePieces === 1 && here.length ? here.join(" · ") : t(`Custom on ${zonePieces} pieces`, `مخصّصة في ${zonePieces} قطع`);
      }
      return { pillow, parts };
    };
    const toFabric = () => {
      const tab = [...document.querySelectorAll("nav.kz-tabs button")].find((b) => /Fabric|القماش/.test(b.textContent));
      if (!tab) return;
      tab.click();
      let n = 0;
      const go = () => {
        const sec = document.querySelector(".kz-panel .kff-parts:not([hidden])");
        if (sec) { sec.scrollIntoView({ block: "start", behavior: "smooth" }); sec.querySelector("button")?.focus({ preventScroll: true }); return; }
        if (++n < 40) setTimeout(go, 100);
      };
      setTimeout(go, 150);
      publish("klik_studio_parts_change", {});
    };
    let watched = null;
    const paint = () => {
      const view = document.querySelector(".kz-panel .kz-view");
      if (!view) return;
      if (watched !== view) ((watched = view), new MutationObserver(() => requestAnimationFrame(paint)).observe(view, { childList: true, subtree: true }));
      const card = view.querySelector(".kz-card.kz-order");
      if (!card) return;
      const sum = summary();
      if (!sum || (!sum.pillow && !sum.parts)) return card.querySelector(".klik-parts-summary")?.remove();
      const key = JSON.stringify(sum);
      let box = card.querySelector(".klik-parts-summary");
      if (box && box.dataset.key === key) return;
      if (!box) {
        box = make("div", "klik-parts-summary");
        const links = card.querySelector(".kz-order-links");
        links ? links.before(box) : card.append(box);
      }
      box.dataset.key = key;
      box.innerHTML =
        (sum.pillow ? `<p><span>${t("Pillow fabric:", "قماش المخدات:")}</span> <strong>${esc(sum.pillow)}</strong></p>` : "") +
        (sum.parts ? `<p><span>${t("Sofa parts:", "أجزاء الكنبة:")}</span> <strong>${esc(sum.parts)}</strong></p>` : "") +
        `<button type="button">${t("Change pillows & parts", "غيّر المخدات والأجزاء")}</button>`;
      box.querySelector("button").addEventListener("click", toFabric);
    };
    const mo = new MutationObserver(() => requestAnimationFrame(paint));
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    document.addEventListener("change", (e) => { if (e.target?.closest?.("[data-klik-dpo-wizard]")) requestAnimationFrame(paint); }, true);
  }
  try { pillowSummary(); } catch (e) {}

  /* ---------- add-to-cart wait: the sectional, bedroom, dining and furniture studios save the 3D design with the
     order before the cart opens (15–30 s on mobile data). The button only fades, so say what is happening. ---------- */
  function addWait() {
    const ADD = /add\b.*\bcart|أضف|إضافة/i;
    const steps = [
      [0, t("Adding your design to the cart…", "جارٍ إضافة تصميمك إلى السلة…")],
      [4000, t("Confirming your price and saving your choices…", "نؤكد السعر ونحفظ اختياراتك…")],
      [12000, t("Almost there: your made-to-order piece is being set up for checkout. This can take up to a minute.", "اقتربنا: نجهّز قطعتك المفصّلة للدفع. قد يستغرق ذلك حتى دقيقة.")],
    ];
    let note = null, timer = null, started = 0, queued = false;
    const stop = () => {
      clearInterval(timer);
      timer = null;
      note?.remove();
      note = null;
    };
    const check = () => {
      // no layout reads: only one studio can be busy adding at a time
      const button = [...document.querySelectorAll(".kd-primary[aria-busy='true']")].find((b) => ADD.test(b.textContent));
      if (!button) return stop();
      if (note?.isConnected) return;
      const footer = button.closest(".kd-footer, .kz-bar, footer") || button.parentElement;
      note = make("div", "kpdp-adding", '<span class="kpdp-adding-bar" aria-hidden="true"></span><span class="kpdp-adding-text" role="status" aria-live="polite"></span>');
      footer.prepend(note);
      started = Date.now();
      const paint = () => {
        const text = steps.filter(([at]) => Date.now() - started >= at).pop()[1];
        const el = note?.querySelector(".kpdp-adding-text");
        if (el && el.textContent !== text) el.textContent = text;
        // the room studios write their own line ("Checking your selection and adding it to your cart…"): keep one message
        const own = [...footer.querySelectorAll(".kd-order-status")].some((s) => s.getClientRects().length && s.textContent.trim());
        if (el && el.hidden !== own) el.hidden = own;
      };
      paint();
      timer = setInterval(paint, 1000);
    };
    // only the studio buttons matter: the options app toggles "disabled" on thousands of inputs while it builds, and
    // measuring on each of those batches cost close to a second when a studio opened
    new MutationObserver((records) => {
      if ((note || records.some((r) => r.target.classList?.contains("kd-primary"))) && !queued) (queued = true), requestAnimationFrame(() => ((queued = false), check()));
    }).observe(document.body, { attributes: true, subtree: true, attributeFilter: ["aria-busy", "disabled"] });
  }
  addWait();

  /* ---------- studio warm-up: build the 3D model and compile its shaders while the shopper reads the page, so
     "Customise in 3D" opens straight into a ready studio. Starts on intent (the buy buttons have been on screen for a
     moment, a finger or the pointer is on them) or after a few seconds on the page, always in idle time; skipped with
     Data Saver, on 2G and on low-memory phones. Uses the theme's own warm hooks (KlikPhotoFirst / KlikModelStartup):
     data-klik-warm makes the closed studio count as open for the 3D startup only (speed.py).
     Made-to-order sofas and corner sofas open on the pictured design, which the product-options app builds first
     (≈12,000 form controls, then the pictured sizes and fabrics). On a mid-range phone that was 15–20 s of work after
     the tap: the 3D appeared ≈17 s and the studio was usable ≈25 s after "Customise in 3D", and the model built
     ahead of time was rebuilt anyway for the pictured design. The studio's own preparation (klikDpoActivate +
     klikPictured.prepare, the same conditions as its open) now runs ahead in pauses of the shopper's reading (no
     touch, scroll or key for a moment), and the model is built afterwards, once, for that exact design. A tap during
     the preparation joins it. The page itself does not change while it runs (checked: no layout shift, same buy
     box). ---------- */
  function warmStudio() {
    const conn = navigator.connection || {};
    if (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || "") || (navigator.deviceMemory || 8) < 3) return;
    const hosts = () => [...document.querySelectorAll("[data-hazel-3d], [data-furniture-3d]")].filter((h) => typeof h.klikWarmModel === "function" || h.klikViewer);
    // heavy steps wait for a pause in the shopper's touches, scrolling and typing, so none lands on a gesture
    let lastInput = performance.now();
    for (const type of ["pointerdown", "touchstart", "keydown", "wheel", "scroll"])
      addEventListener(type, () => (lastInput = performance.now()), { capture: true, passive: true });
    const whenQuiet = (fn, quiet = 800) => {
      const tick = () => {
        if (document.hidden) return void document.addEventListener("visibilitychange", tick, { once: true });
        const wait = lastInput + quiet - performance.now();
        if (wait > 0) return void setTimeout(tick, wait + 60);
        typeof requestIdleCallback === "function" ? requestIdleCallback(fn, { timeout: 1500 }) : setTimeout(fn, 60);
      };
      tick();
    };
    // the pictured design is prepared under the same conditions as the studio's own open (klik-configurator-workspace)
    const pictured = () => {
      if (/[?&](studio=1|klik_sofa_mode=)/.test(location.search) || /klik-(config|design)/.test(location.hash)) return null;
      const w = [...document.querySelectorAll("[id^='KlikDpoWizard-']")].find((x) => x.klikPictured);
      if (!w || w.dataset.klikDesignRestored === "true" || document.documentElement.classList.contains("hz-studio-active")) return null;
      try {
        if (w.klikPictured.hasSaved?.()) return null;
      } catch {
        return null;
      }
      return w.closest("[data-kpd-page]")?.querySelector(".kp6-purchase")?.dataset.priceState === "estimate" ? w : null;
    };
    // furniture studios (ottomans, tables, chairs) have no pictured preparation, but open on the same options form
    const furniture = () =>
      !/[?&](studio=1|klik_sofa_mode=)/.test(location.search) &&
      !/klik-(config|design)/.test(location.hash) &&
      window.klikDpoConfigDeferred === true &&
      !!document.querySelector("[data-furniture-configurator]");
    let started = false;
    const start = () => {
      if (started || document.hidden) return;
      const list = hosts().filter((h) => !h.klikViewer);
      if (!list.length) return;
      started = true;
      const w = pictured();
      // p5-cfg-entry A2: a tap before the options loader is defined (it waits for jQuery) waits for it, so the pictured
      // design is still prepared first (the model is then built once, for that design)
      if ((w || furniture()) && typeof window.klikDpoActivate !== "function" && (start.tries = (start.tries || 0) + 1) < 40) return void ((started = false), setTimeout(start, 250));
      if ((!w && !furniture()) || typeof window.klikDpoActivate !== "function") return warm(list);
      // the studio script (renderer, lighting) downloads and starts while the options are prepared, instead of after
      try {
        window.KlikModelStartup?.studio?.();
      } catch {}
      whenQuiet(() => {
        window.klikDpoActivate();
        const t0 = performance.now();
        // the options form is in (its data was fetched with the page): dress the pictured design in the next pause
        const ready = () => window.dpoOptions?.options?.length && document.getElementById("itoris_dynamicproductoptions");
        // the model is built as soon as the pictured design is dressed (before its price capture has finished), or,
        // in a furniture studio, as soon as the options form is in
        let warmed = false;
        const warmOnce = () => warmed || ((warmed = true), whenQuiet(() => warm(list), 300));
        const go = () =>
          whenQuiet(() => {
            if (!w) {
              // furniture: the studio's own options set-up first (speed.py klikPrepare), so the model is built once,
              // for the size and fabric the studio opens on
              let prep;
              try {
                prep = document.querySelector("[data-furniture-configurator]")?.klikPrepare?.();
              } catch (error) {
                prep = Promise.reject(error);
              }
              return void Promise.resolve(prep).catch(() => {}).finally(warmOnce);
            }
            let job;
            try {
              job = w.klikPictured.prepare(warmOnce);
            } catch (error) {
              job = Promise.reject(error);
            }
            Promise.resolve(job).catch(() => {}).finally(warmOnce);
          });
        const wait = () => (ready() ? go() : performance.now() - t0 > 30000 ? warm(list) : setTimeout(wait, 250));
        wait();
      });
    };
    const warm = (list) => {
      let studio = null;
      try {
        studio = window.KlikModelStartup?.studio?.();
      } catch {}
      // the studio script (it owns the designed lighting environment) and the environment file must be in before a
      // model is built, or the viewer falls back to a generated environment and lights the piece differently
      const env = window.KlikSeatingEnvironment?.ready;
      // p4-cta: the model build (seconds of main-thread work) waits while "Buy as pictured" is adding, so it never slows
      // the add down (buy-fix CO-6 measured 11.2 s → 2.85 s without it); it runs right after
      const notAdding = () =>
        new Promise((go) => {
          const t0 = Date.now();
          const tick = () => (document.querySelector('.kpdp-cta-add[data-state="loading"]') && Date.now() - t0 < 90000 ? setTimeout(tick, 500) : go());
          tick();
        });
      Promise.race([Promise.all([studio, env].map((p) => Promise.resolve(p).catch(() => {}))), new Promise((r) => setTimeout(r, 6000))]).then(notAdding).then(() => {
        for (const h of list) {
          if (h.klikViewer) continue;
          h.dataset.klikWarm = "1";
          try {
            h.klikWarmModel();
          } catch {}
        }
      });
      const t0 = Date.now();
      const poll = setInterval(() => {
        let pending = 0;
        for (const h of document.querySelectorAll("[data-klik-warm='1']")) {
          const viewer = h.klikViewer;
          if (h.dataset.klikWarmCompiled) continue;
          if (viewer?.model && h.dataset.geometry === "ready") {
            h.dataset.klikWarmCompiled = "1";
            try {
              viewer.renderer?.klikPrecompile?.();
            } catch {}
          } else pending++;
        }
        if (!pending || Date.now() - t0 > 60000) clearInterval(poll);
      }, 400);
    };
    const soon = () => (typeof requestIdleCallback === "function" ? requestIdleCallback(start, { timeout: 1500 }) : setTimeout(start, 300));
    // strongest signal: a finger or the pointer on the 3D buttons (the tap follows a moment later). buy-fix2 (CO-6): not on
    // Add to cart (.kflow-as-shown / .kpdp-bar-buy) — every family adds through its own adapter without the 3D model, and
    // the model build on that tap starved the add (ready 11.2 s -> 2.85 s, kz ValidateForm 7.2 -> 5.8 s without it)
    const SEL = ".kflow-primary, .kpdp-bar__3d, .kpdp-bar-buy--3d, .kpdp-fv__customise, .kflow-dock-button";
    // p5-cfg-entry A2: the DPO files the studio needs are requested at once on intent (network only): the one copy of
    // include.js (the priority header's own injector, sofa sets and furniture) and its two option scripts, preloaded so
    // they do not wait for include.js and its config round trip. klikDpoActivate (config only, it never validates) runs
    // in the first quiet moment after the first view painted.
    const dpoEarly = () => {
      // only on the DPO studios (sofa sets, corner sofas, furniture); rooms never load DPO
      if (!document.querySelector("[data-klik-dpo-wizard], [data-furniture-configurator]") || document.querySelector("#kl-room-shop")) return;
      try { window.klikDpoInject?.(); } catch (e) {}
      if (window.dpoOptions?.options?.length || document.querySelector("script[src*='/dpo/storefront/assets/js/options.js']")) return;
      // a preload never executes: the one copy of include.js is still added by DPO's own loader, which then finds it cached
      const inc = "https://node1.itoris.com/dpo/storefront/include.js?shop=clickfurniture.myshopify.com";
      for (const href of document.querySelector("script[src*='/dpo/storefront/include.js']") ? [] : [inc]) {
        if (document.querySelector(`link[href="${href}"]`)) continue;
        const l = document.createElement("link");
        l.rel = "preload";
        l.as = "script";
        l.href = href;
        document.head.append(l);
      }
      for (const href of ["https://node1.itoris.com/dpo/storefront/assets/js/options.js?v=43", "https://node1.itoris.com/dpo/storefront/assets/js/formula.js?v=3"]) {
        if (document.querySelector(`link[href="${href}"]`)) continue;
        const l = document.createElement("link");
        l.rel = "preload";
        l.as = "script";
        l.href = href;
        document.head.append(l);
      }
    };
    let activated = false;
    const activateSoon = () => {
      if (activated) return;
      activated = true;
      let tries = 0;
      const go = () => {
        if (typeof window.klikDpoActivate === "function") return void whenQuiet(() => { try { window.klikDpoActivate(); } catch (e) {} }, 600);
        if (++tries < 60) setTimeout(go, 250);
      };
      go();
    };
    warmHook = (source) => {
      dpoEarly();
      if (source === "first-view" || source === "bar") start();
      if (source === "first-view") activateSoon();
      prefetch();
    };
    for (const type of ["pointerdown", "pointerover", "focusin"])
      document.addEventListener(type, (e) => e.target.closest?.(SEL) && start(), { capture: true, passive: true });
    // PF-01 (2026-10-21): the two automatic warm-ups (buy buttons on screen for 0.6 s, and 1.2 s after load) cost
    // 5–7 s of main-thread work on every product view (PERF-PLAN §3). Default policy: the studio is prepared on
    // intent only (above), and after load + idle the network only fetches the studio files (prefetch), so the tap
    // finds them in the cache. ● Owner switch (PACKAGES §8): "warm" restores today's automatic warm-up.
    const WARM_POLICY = "prefetch"; // "prefetch" | "warm"
    if (WARM_POLICY === "warm") {
      const later = () => setTimeout(soon, 1200);
      document.readyState === "complete" ? later() : addEventListener("load", later, { once: true });
      return;
    }
    // v3-fix-perf (2026-10-22): only what THIS page's studio opens with — the shared studio + lighting and the page's
    // own 3D engine (the viewer host's data-viewer-src: sectional-batch / hazel-3d on corner pages, sofa-catalog-3d on
    // sofa sets, furniture-catalog-3d on furniture). The room-set table engine (furniture-catalog-3d on sofa and corner
    // pages) is no longer prefetched: klik-room-set loads it when a table is added. Skipped on Save-Data and 3G or slower.
    /* wave1-fix pdp SP-08 (studio builder's request): each studio file is fetched once. The loaders add their scripts
       with absolute URLs while the data-* attributes hold protocol-relative ones, so the old attribute match never saw
       them; a file now counts as requested when a script or link on the page, or a finished resource, has the same
       resolved URL. The engine is skipped once its loader has added it (script[data-klik-model-engine]). */
    const abs = (u) => {
      try { return new URL(u, location.href).href; } catch (e) { return String(u); }
    };
    const requested = (u) => {
      const h = abs(u);
      if ([...document.scripts].some((s) => s.src === h) || [...document.querySelectorAll("link[href]")].some((l) => l.href === h)) return true;
      try { return performance.getEntriesByName(h).length > 0; } catch (e) { return false; }
    };
    const prefetch = () => {
      if (conn.saveData || /(^|-)(2g|3g)$/.test(conn.effectiveType || "")) return;
      const viewer = document.querySelector("[data-hazel-3d][data-viewer-src], [data-furniture-3d][data-viewer-src]")?.dataset.viewerSrc || "";
      // SP-08, measured after the change above (dd-check, staging Sira): corner pages (sectional-batch / hazel-3d engines)
      // prepare their studio themselves on a reading pause (fast devices) or on the tap, and that warm-up requested the
      // studio, lighting and engine while this low-priority prefetch was still downloading them, so they came twice. The
      // builder's fallback: no prefetch on corner pages (slow devices load the files on the tap).
      if (/sectional-batch|hazel-3d/.test(viewer)) return;
      const cfg = document.querySelector("script[data-klik-studio-src]");
      const engine = document.querySelector("script[data-klik-model-engine]") ? null : viewer;
      const urls = new Set([cfg?.dataset.klikStudioSrc, cfg?.dataset.lightingSrc, engine].filter((u) => u && !requested(u)));
      for (const href of urls) {
        const link = document.createElement("link");
        link.rel = "prefetch";
        link.href = href;
        link.as = /\.json(\?|$)/.test(href) ? "fetch" : "script";
        if (link.as === "fetch") link.crossOrigin = "anonymous";
        document.head.append(link);
      }
    };
    // after load, the first touch / scroll / key (then a quiet moment) or 5 s, whichever comes first, so the prefetch
    // never competes with the first screen or lands on a gesture (Add to cart, 3D)
    let armed = false;
    // SP-08: the prefetch waits for a quiet moment and then for idle time (3 s at most), never during load
    const idlePrefetch = () => (typeof requestIdleCallback === "function" ? requestIdleCallback(prefetch, { timeout: 3000 }) : setTimeout(prefetch, 600));
    const arm = () => armed || ((armed = true), whenQuiet(idlePrefetch, 700));
    /* p5-cfg-entry A2 / A12: on phones the idle prefetch runs only on fast ones (4G, 4 GB or more, no Data Saver); every
       phone that is not slow fetches the files when the one button comes within 600 px of the screen (network only).
       SP-08: that watch starts after window load (it fired during load, and its low-priority prefetch was still in
       flight when the corner studio's own warm-up requested the same files, which were then downloaded twice). */
    const phone = matchMedia("(max-width: 989px)").matches;
    const fastPhone = !conn.saveData && (conn.effectiveType || "4g") === "4g" && (navigator.deviceMemory || 4) >= 4;
    const watchNear = () => {
      // read at load time: the server button may have been swapped for its adopted copy by then
      const near = document.querySelector(".kpdp-cta--studio .kpdp-cta-3d--primary, .kflow-primary");
      if (!near || !("IntersectionObserver" in window) || conn.saveData) return;
      const io = new IntersectionObserver((entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        io.disconnect();
        whenQuiet(idlePrefetch, 500);
      }, { rootMargin: fastPhone || !phone ? "600px" : "0px" });
      io.observe(near);
    };
    const afterLoad = () => {
      watchNear();
      if (phone && !fastPhone) return;
      for (const type of ["pointerdown", "touchstart", "keydown", "scroll", "wheel"]) addEventListener(type, arm, { once: true, capture: true, passive: true });
      setTimeout(arm, 5000);
    };
    document.readyState === "complete" ? afterLoad() : addEventListener("load", afterLoad, { once: true });
  }

  /* ---------- wait for the family controllers to mount their buy box ---------- */
  const tryMount = () => {
    const box = document.querySelector(".kp6-purchase .kflow, .kl-pdp-panel .kflow");
    if (box) {
      enhance(box);
      if (!window.__klikWarmSet) (window.__klikWarmSet = true), warmStudio();
      if (!window.__kpdpPlusArmed) {
        window.__kpdpPlusArmed = 1;
        const later = () => (typeof requestIdleCallback === "function" ? requestIdleCallback(loadPlus, { timeout: 4000 }) : setTimeout(loadPlus, 1500));
        document.readyState === "complete" ? later() : addEventListener("load", later, { once: true });
      }
    }
    galleryCounter();
    return !!box;
  };
  if (!tryMount()) {
    const watcher = new MutationObserver(() => tryMount() && watcher.disconnect());
    watcher.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => watcher.disconnect(), 20000);
  }
  // §1.13a: a server CTA block (klik-pdp-actions.liquid) that no studio adopted (a product without a studio) goes, so no
  // dead button stays on screen; klik-product-flow.js builds the same markup if a studio mounts later
  const dropOrphans = () => setTimeout(() => document.querySelectorAll("[data-kpdp-actions]:not([data-kpdp-adopted])").forEach((n) => n.remove()), 10000);
  document.readyState === "complete" ? dropOrphans() : addEventListener("load", dropOrphans, { once: true });
})();
